<template>
  <div class="page">
    <div class="banner_box">
      <!-- <el-carousel :interval="5000" arrow="always">
        <el-carousel-item > -->
      <img src="../assets/programme/banner5.jpg" alt="行业解决方案背景图" />
      <!-- </el-carousel-item>
      </el-carousel> -->
    </div>

    <div id="content" :class="show1 ? 'header1' : ''"></div>

    <div style="height: 15px"></div>
    <div class="content">
      <div
        class="header"
        :class="show ? 'header' : 'issFixed'"
        @click="gotoback"
      >
        <div
          class="case_item"
          :class="Cindex == index ? 'active' : ''"
          :style="{
            'background-image':
              Cindex == index ? 'url(' + item.bgIMG + ')' : '',
          }"
          v-for="(item, index) in caseTabs"
          :key="index"
          @click="caseClick(index)"
        >
          <div :class="Cindex == index ? 'active_bg' : 'bg'">
            <img :src="Cindex == index ? item.img : item.imgURL" alt="切换按钮背景图片" />
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="Scheme_overview" ref="header">
        <div class="title">
          <span></span>
          <h2>方案概述</h2>
        </div>
        <!-- 方案概述 -->

        <div></div>
        <div class="overview" v-if="this.Cindex == 0">
          <p>{{ overview1 }}</p>
          <p>{{ overview2 }}</p>
        </div>
        <div class="overview" v-if="this.Cindex == 1">
          <p>{{ overview11 }}</p>
          <p>{{ overview22 }}</p>
        </div>
        <div class="overview3" v-if="this.Cindex == 2">
          <p>{{ overview23 }}</p>
          <!-- <p>{{ overview23 }}</p> -->
        </div>
        <div class="features" v-if="this.Cindex == 0">
          <p>基本特征</p>
          <p></p>
          <div class="analysis">
            <img src="../assets/programme/img1.png" alt="透彻感知图片" />
            <div>透彻感知</div>
          </div>
          <p class="features_p3"></p>
          <div class="analysis">
            <img src="../assets/programme/img2.png" alt="远程控制图片" />
            <div>远程控制</div>
          </div>
          <p class="features_p4"></p>
          <div class="analysis">
            <img src="../assets/programme/img3.png" alt="自动预警图片" />
            <div>自动预警</div>
          </div>
          <p class="features_p5"></p>
          <div class="analysis">
            <img src="../assets/programme/img4.png" alt="智能分析图片" />
            <div>智能分析</div>
          </div>
        </div>
        <!-- 建设思路 -->

        <div class="construction" v-if="this.Cindex == 0" id="">
          <div id="construction1" class="construction11"></div>
          <div class="title">
            <span></span>
            <h2>建设思路</h2>
          </div>
          <p class="overview3" style="margin-top: 70px">{{ overview3 }}</p>
          <div class="mentality">
            <ul>
              <li>
                <img src="../assets/programme/img5.png" alt="智慧水利云计算数据中心图片" />
                <p>智慧水利云计算数据中心</p>
              </li>
              <li>
                <img src="../assets/programme/img6.png" alt="智慧水利数据源采集平台图片" />
                <p>智慧水利数据源采集平台</p>
              </li>
              <li>
                <img src="../assets/programme/img7.png" alt="智慧水利一体化应用平台图片" />
                <p>智慧水利一体化应用平台</p>
              </li>
            </ul>
          </div>
        </div>

        <div
          class="construction"
          v-if="this.Cindex == 1"
          style="padding-bottom: 250px"
        >
          <div id="construction2" class="construction22"></div>
          <div class="title">
            <span></span>
            <h2>建设思路</h2>
          </div>
          <p class="overview3">{{ overview31 }}</p>

          <div class="mentality" v-if="this.Cindex == 0">
            <ul>
              <li>
                <img src="../assets/programme/img5.png" alt="智慧水利云计算数据中心图片" />
                <p>智慧水利云计算数据中心</p>
              </li>
              <li>
                <img src="../assets/programme/img6.png" alt="智慧水利数据源采集平台图片" />
                <p>智慧水利数据源采集平台</p>
              </li>
              <li>
                <img src="../assets/programme/img7.png" alt="智慧水利一体化应用平台图片" />
                <p>智慧水利一体化应用平台</p>
              </li>
            </ul>
          </div>
          <div class="mentality1" v-if="this.Cindex == 1">
            <div style="display: flex">
              <div class="left_box">
                <img src="../assets/programme/a.png" alt="建设思路图片" />
              </div>
              <div class="right_box">
                <div class="right_box_left">
                  <div class="right_box_box">
                    <img src="../assets/programme/b.png" alt="平台图片" />
                    <p>统一平台</p>
                  </div>
                  <div class="right_box_size">
                    <p>
                      基于政务外网，建设智慧城管的指挥、监督、处置、评价等应用平台以及数据交换平台，按照智慧城管共享平台统筹规划、统一设计。
                    </p>
                  </div>
                </div>
                <div class="right_box_left">
                  <div class="right_box_box">
                    <img src="../assets/programme/c.png" alt="受理图片" />
                    <p>统一受理</p>
                  </div>
                  <div class="right_box_size">
                    <p>
                      建立呼叫中心，统一受理市民、监督员上报的案卷以及领导派发的案卷。通过受理平台，将城管业务举报和投诉集中统一处理。
                    </p>
                  </div>
                </div>
                <div class="right_box_left">
                  <div class="right_box_box">
                    <img src="../assets/programme/d.png" alt="监督图片" />
                    <p>统一监督</p>
                  </div>
                  <div class="right_box_size">
                    <p class="p1">
                      设立监督中心，负责对城管事件的处置情况进行跟踪、考核和评估，并通过城市运行管理门户网站统一对外发布。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="top_box">
              <div class="bottom_box">
                <div class="top">
                  <div class="top_top">
                    <p>全民城管平台</p>
                    <p>城市智慧平台</p>
                    <p>城市感知平台</p>
                  </div>
                  <div class="top_bottom">
                    <div class="list1">
                      <p>服务网站</p>
                      <p>微信互动</p>
                      <p>APP互动</p>
                      <p>市民热线</p>
                      <span></span>
                    </div>
                    <div class="list1 list2">
                      <p>协调工作</p>
                      <p>部件更新</p>
                      <p>监督指挥</p>
                      <span></span>
                    </div>
                    <div class="list1 list3">
                      <p>视频监控</p>
                      <p>智能定位</p>
                      <p>设备检测</p>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list">
                <p>执法部门</p>
                <span></span>
                <p>各专业局</p>
                <span></span>
                <p>各专业部门</p>
                <span></span>
                <p>各专业公司</p>
                <span></span>
                <p>社会团体</p>
                <span></span>
                <p>公众市民</p>
              </div>
              <div class="left_box_content">
                <div style="margin-top: -20px">
                  <p>7大类城市管理部件</p>
                  <p><span>01</span> 市政公用设施</p>
                  <p><span>02</span> 道路交通设施</p>
                  <p><span>03</span> 市容环境</p>
                  <p><span>04</span> 园林绿化</p>
                  <p><span>05</span> 房屋建筑</p>
                  <p><span>06</span> 其他设施</p>
                  <p><span>07</span> 扩展部件</p>
                </div>
              </div>
              <div class="right_box_content">
                <div style="margin-top: 0px">
                  <p>6大类城市管理事件</p>
                  <p><span>01</span> 市容环境类</p>
                  <p><span>02</span> 宣传广告类</p>
                  <p><span>03</span> 施工管理类</p>
                  <p><span>04</span> 突发事件类</p>
                  <p><span>05</span> 街面秩序类</p>
                  <p><span>06</span> 扩展事件</p>
                </div>
              </div>
              <div class="left_box">
                <div class="left_box_ball"></div>
                <div class="left_box_line"></div>
              </div>
              <div class="right_box">
                <div class="right_box_ball"></div>
                <div class="right_box_line"></div>
              </div>
              <div class="top_box">
                <div class="center_box">
                  <img src="../assets/programme/e.png" alt="智慧城管综合管理平台图片" />
                </div>
                <div class="box_ball"></div>
                <div class="box_ball"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="construction3" v-if="this.Cindex == 2">
          <div id="construction3" class="construction33"></div>
          <div class="title">
            <span></span>
            <h2>建设思路</h2>
          </div>

          <p class="overview3">{{ overview32 }}</p>
          <div style="display: flex; margin-top: 90px">
            <img
              v-if="this.Cindex == 2"
              src="../assets/programme/c4a2762a51061f7665b6eba43859560.jpg"
              width="1125px"
              height="380px"
              alt="建设思路大图"
            />
          </div>

          <div class="mentality" v-if="this.Cindex == 0">
            <ul>
              <li>
                <img src="../assets/programme/img5.png" alt="智慧水利云计算数据中心图片" />
                <p>智慧水利云计算数据中心</p>
              </li>
              <li>
                <img src="../assets/programme/img6.png" alt="智慧水利数据源采集平台图片" />
                <p>智慧水利数据源采集平台</p>
              </li>
              <li>
                <img src="../assets/programme/img7.png" alt="智慧水利一体化应用平台图片" />
                <p>智慧水利一体化应用平台</p>
              </li>
            </ul>
          </div>
          <div class="mentality1" v-if="this.Cindex == 1">
            <div style="display: flex">
              <div class="left_box">
                <img src="../assets/programme/a.png" alt="建设思路大图" />
              </div>
              <div class="right_box">
                <div class="right_box_left">
                  <div class="right_box_box">
                    <img src="../assets/programme/b.png" alt="平台图片" />
                    <p>统一平台</p>
                  </div>
                  <div class="right_box_size">
                    <p>
                      基于政务外网，建设智慧城管的指挥、监督、处置、评价等应用平台以及数据交换平台，按照智慧城管共享平台统筹规划、统一设计。
                    </p>
                  </div>
                </div>
                <div class="right_box_left">
                  <div class="right_box_box">
                    <img src="../assets/programme/c.png" alt="受理图片" />
                    <p>统一受理</p>
                  </div>
                  <div class="right_box_size">
                    <p>
                      建立呼叫中心，统一受理市民、监督员上报的案卷以及领导派发的案卷。通过受理平台，将城管业务举报和投诉集中统一处理。
                    </p>
                  </div>
                </div>
                <div class="right_box_left">
                  <div class="right_box_box">
                    <img src="../assets/programme/d.png" alt="监督图片" />
                    <p>统一监督</p>
                  </div>
                  <div class="right_box_size">
                    <p class="p1">
                      设立监督中心，负责对城管事件的处置情况进行跟踪、考核和评估，并通过城市运行管理门户网站统一对外发布。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="top_box">
              <div class="bottom_box">
                <div class="top">
                  <div class="top_top">
                    <p>全民城管平台</p>
                    <p>城市智慧平台</p>
                    <p>城市感知平台</p>
                  </div>
                  <div class="top_bottom">
                    <div class="list1">
                      <p>服务网站</p>
                      <p>微信互动</p>
                      <p>APP互动</p>
                      <p>市民热线</p>
                      <span></span>
                    </div>
                    <div class="list1 list2">
                      <p>协调工作</p>
                      <p>部件更新</p>
                      <p>监督指挥</p>
                      <span></span>
                    </div>
                    <div class="list1 list3">
                      <p>视频监控</p>
                      <p>智能定位</p>
                      <p>设备检测</p>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list">
                <p>执法部门</p>
                <span></span>
                <p>各专业局</p>
                <span></span>
                <p>各专业部门</p>
                <span></span>
                <p>各专业公司</p>
                <span></span>
                <p>社会团体</p>
                <span></span>
                <p>公众市民</p>
              </div>
              <div class="left_box_content">
                <div style="margin-top: -20px">
                  <p>7大类城市管理部件</p>
                  <p><span>01</span> 市政公用设施</p>
                  <p><span>02</span> 道路交通设施</p>
                  <p><span>03</span> 市容环境</p>
                  <p><span>04</span> 园林绿化</p>
                  <p><span>05</span> 房屋建筑</p>
                  <p><span>06</span> 其他设施</p>
                  <p><span>07</span> 扩展部件</p>
                </div>
              </div>
              <div class="right_box_content">
                <div style="margin-top: 0px">
                  <p>6大类城市管理事件</p>
                  <p><span>01</span> 市容环境类</p>
                  <p><span>02</span> 宣传广告类</p>
                  <p><span>03</span> 施工管理类</p>
                  <p><span>04</span> 突发事件类</p>
                  <p><span>05</span> 街面秩序类</p>
                  <p><span>06</span> 扩展事件</p>
                </div>
              </div>
              <div class="left_box">
                <div class="left_box_ball"></div>
                <div class="left_box_line"></div>
              </div>
              <div class="right_box">
                <div class="right_box_ball"></div>
                <div class="right_box_line"></div>
              </div>
              <div class="top_box">
                <div class="center_box">
                  <img src="../assets/programme/e.png" alt="智慧城管综合管理平台大图" />
                </div>
                <div class="box_ball"></div>
                <div class="box_ball"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="Solution_Architecture3" v-if="this.Cindex == 2">
          <div
            id="Solution_Architecture4"
            class="Solution_Architecture33"
          ></div>
          <div class="title">
            <span></span>
            <!-- <span>总体架构</span> -->
            <h2>建设目标</h2>
          </div>
          <!-- <img
            src="../assets/programme/cg4.jpg"
            alt=""
            style="margin: 40px auto 0px"
            width="1002px"
            height="873px"
          /> -->
          <p style="line-height: 25px; margin: 40px auto">{{ overview7 }}</p>
          <div class="bottom_box">
            <div class="bottom_box_list">
              <img src="../assets/programme/js1.png" alt="协同图标" />
              <p class="list_p">高效协同</p>
              <p>基于物联网服务简化农业管理流程，提升农业智能化管理效率；</p>
            </div>
            <div class="bottom_box_list">
              <img src="../assets/programme/js2.png" alt="决策图标" />
              <p class="list_p">科学决策</p>
              <p>凭借大数据分析和人工智能，提升农业智能化管理决策水平；</p>
            </div>
            <div class="bottom_box_list">
              <img src="../assets/programme/js3.png" alt="环保图标" />
              <p class="list_p">绿色环保</p>
              <p>依靠最新的技术，构建农业节能节排，绿色环保体系；</p>
            </div>
            <div class="bottom_box_list">
              <img src="../assets/programme/js4.png" alt="保障图标" />
              <p class="list_p">应急保障</p>
              <p>
                利用实时监控和实时决策，通过数据共享和交换平台，建立科学系统应急保障联动机制。
              </p>
            </div>
          </div>
        </div>

        <div class="Construction_goal" v-if="this.Cindex == 2">
          <div id="Solution_Architecture3" class="Construction_goal22"></div>
          <div class="title">
            <span></span>
            <h2>总体架构</h2>
          </div>
          <img
            src="../assets/programme/cg4.jpg"
            alt="农业架构图片"
            style="margin: 40px auto 0px"
            width="1002px"
            height="873px"
          />
        </div>

        <div>
          <div class="architecture" v-if="this.Cindex == 0">
            <div id="architecture1" class="architecture11"></div>
            <div class="title">
              <span></span>
              <h2>总体架构</h2>
            </div>
            <p class="overview4">{{ overview4 }}</p>
            <div style="text-align: center; margin-top: 52px">
              <img
                src="../assets/programme/b43a54f4a27f460c7c1f9fcf4d44f8e.jpg"
                width="1002px"
                height="873"
                alt="智慧水利架构大图"
              />
            </div>
          </div>
          <div class="architecture3" v-if="this.Cindex == 2">
            <div id="architecture3" class="architecture33"></div>
            <div class="title">
              <span></span>
              <h2>功能模块</h2>
            </div>
            <p class="overview4">{{ overview41 }}</p>
            <div style="text-align: center">
              <img
                src="../assets/programme/72e788db5645b0a8151441a21c5fc2e.jpg"
                alt="农业功能模块大图"
              />
            </div>
          </div>

          <!-- 建设内容 -->

          <div class="undertaking" v-if="this.Cindex == 0">
            <div id="undertaking1" class="undertaking11"></div>
            <div class="title">
              <span></span>
              <h2>建设内容</h2>
            </div>
            <p
              style="
                width: 667px;
                height: 18px;
                line-height: 25px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
              "
            >
              智慧水利综合管理平台围绕一个云数据中心，进行智慧水利“六大建设”内容拓展。
            </p>
            <img src="../assets/programme/img9.png" alt="水利建设内容大图" />
          </div>

          <div
            class="undertaking2"
            style="padding-bottom: 60px"
            v-if="this.Cindex == 1"
          >
            <div id="undertaking2" class="undertaking22"></div>
            <div class="title">
              <span></span>
              <h2>建设内容</h2>
            </div>
            <p
              style="
                width: 801px;
                height: 19px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
              "
            >
              智慧城管综合管理平台围绕“新服务、新管理、新应用、新资源、新技术”
              五个方面进行内容拓展。
            </p>
            <div class="title_content">
              <div class="listt">
                <img src="../assets/programme/content1.png" alt="服务图标" />
                <p>新服务 (公众)</p>
                <span></span>
                <div class="top_box"></div>
                <div style="margin-top: -25px">
                  <p>公众充分参与</p>
                  <p>政府主动预知</p>
                  <p>部门快捷互动</p>
                </div>

                <div class="bottom_box" style="margin-top: 60px"></div>
                <span></span>
                <div class="bottom_div">更主动的服务</div>
              </div>
              <div class="listt">
                <img src="../assets/programme/content2.png" alt="管理图标" />
                <p>新管理 (基层)</p>
                <span></span>
                <div class="top_box"></div>
                <div style="margin-top: -25px">
                  <p>更智能的监督</p>
                  <p>更快捷的处置</p>
                  <p>更高效的协同</p>
                  <p>更科学的决策</p>
                  <p>......</p>
                </div>
                <div class="bottom_box"></div>
                <span></span>
                <div class="bottom_div">更高效的管理</div>
              </div>
              <div class="listt">
                <img src="../assets/programme/content3.png" alt="应用图标" />
                <p>新应用</p>
                <span></span>
                <div class="top_box"></div>
                <div style="margin-top: -25px">
                  <p>全移动应用</p>
                  <p>全智能应用</p>
                  <p>全场景应用</p>
                  <p>全时空应用</p>
                  <p>......</p>
                </div>
                <div class="bottom_box"></div>
                <span></span>
                <div class="bottom_div">更智能的应用</div>
              </div>
              <div class="listt">
                <img src="../assets/programme/content4.png" alt="资源图标" />
                <p>新资源</p>
                <span></span>
                <div class="top_box"></div>
                <div style="margin-top: -25px">
                  <p>公共事业监测信息</p>
                  <p>地下管网信息</p>
                  <p>视频监控信息</p>
                  <p>机动车信息</p>
                  <p>......</p>
                </div>
                <div class="bottom_box"></div>
                <span></span>
                <div class="bottom_div">更丰富的资源</div>
              </div>
              <div class="listt">
                <img src="../assets/programme/content5.png" alt="技术图标" />
                <p>新技术</p>
                <span></span>
                <div class="top_box"></div>
                <div style="margin-top: -25px">
                  <p>移动互联网</p>
                  <p>物联网</p>
                  <p>GIS地图</p>
                  <p>大数据</p>
                  <p>......</p>
                </div>
                <div class="bottom_box"></div>
                <span></span>
                <div class="bottom_div">更实用的技术</div>
              </div>
              <!-- <div class="listt">
                <img src="../assets/programme/content1.png" alt="" />
                <p>新服务 (公众)</p>
                <span></span>
              </div>
                  <div class="listt">
                <img src="../assets/programme/content1.png" alt="" />
                <p>新服务 (公众)</p>
                <span></span>
              </div>
                  <div class="listt">
                <img src="../assets/programme/content1.png" alt="" />
                <p>新服务 (公众)</p>
                <span></span>
              </div>
                  <div class="listt">
                <img src="../assets/programme/content1.png" alt="" />
                <p>新服务 (公众)</p>
                <span></span>
              </div> -->
            </div>
          </div>

          <div class="functional_module" v-if="this.Cindex == 0">
            <div id="functional_module1" class="functional_module11"></div>

            <div class="title">
              <span></span>
              <h2>功能模块</h2>
            </div>
            <p class="overview5">{{ overview5 }}</p>

            <img src="../assets/programme/img10.png" alt="水利功能模块大图" />
          </div>
          <div class="functional_module2" v-if="this.Cindex == 1">
            <div id="functional_module2" class="functional_module22"></div>
            <div class="title">
              <span></span>
              <h2>总体架构</h2>
            </div>
            <p class="overview5">{{ overview51 }}</p>
            <p class="overview5" style="margin-top: 15px">{{ overview52 }}</p>
            <div class="module_div">
              <img
                width="1002px"
                height="873px"
                src="../assets/programme/cg2.jpg"
                alt="城管总体架构大图"
              />
            </div>
          </div>

          <div class="Enterprise_Architecture" v-if="this.Cindex == 1">
            <div
              id="Enterprise_Architecture2"
              class="Enterprise_Architecture22"
            ></div>
            <div class="title">
              <span></span>
              <h2>功能模块</h2>
            </div>
            <p
              class="overview6"
              style="line-height: 25px; margin-top: 45px; margin-bottom: 45px"
            >
              {{ overview6 }}
            </p>
            <img
              src="../assets/programme/a406c34653216db1176c0f8377de0f4.jpg"
              alt="城管功能模块大图"
              width="1153px"
            />
          </div>

          <div class="Related_Products" v-if="this.Cindex == 0">
            <div id="Related_Products1" class="Related_Products11"></div>
            <!-- <div class="title">
              <span></span>
              <span>相关产品</span>
            </div> -->

            <div class="title">
              <span></span>
              <h2>软件产品</h2>
            </div>
            <div class="tabs">
              <ul>
                <li v-for="(item, index) in Software" :key="index">
                  <!-- <img
                    :src="item.proIcon"
                    width="100px"
                    height="100px"
                    alt=""
                    style="cursor: pointer"
                    @click="gotoSoftWareShuiDetail(item)"
                  /> -->
                  <a :href="`#/softwareDetail/${item.proId}/1`">
                    <img
                    :src="item.proIcon"
                    width="100px"
                    height="100px"
                    alt="软件产品图标"
                    style="cursor: pointer"
                  />
                  </a>
                  <p>{{ item.proName }}</p>
                </li>
              </ul>
            </div>

            <div class="title">
              <span></span>
              <h2>硬件产品</h2>
            </div>
            <div class="list">
              <!-- <img
                class="img1"
                @click="prev()"
                src="../assets/icon/left.png"
                alt=""
              />
              <img
                class="img2"
                @click="next()"
                src="../assets/icon/right.png"
                alt=""
              /> -->
              <div
                class="item"
                v-for="(item, index) in HardwareList"
                :key="index"
              >
                <div class="devImg">
                  <img :src="item.devImg" alt="硬件产品展示图" />
                </div>
                <div class="text">
                  <p>{{ item.devName }}</p>
                  <button @click="gotoDetail(item)">详情参数</button>
                </div>
              </div>
            </div>

            <!-- <div class="tabs">
              <el-tabs v-model="activeName" class="demo-tabs">
                <el-tab-pane label="软件产品" name="software">
                  <ul>
                    <li v-for="(item, index) in Software" :key="index">
                      <img
                        :src="item.proIcon"
                        width="100px"
                        height="100px"
                        alt=""
                      />
                      <p>{{ item.proName }}</p>
                    </li>
                  </ul>
                </el-tab-pane>
                <el-tab-pane label="硬件产品" name="hardware">

                  <div class="list">
                    <div
                      class="item"
                      v-for="(item, index) in hardware"
                      :key="index"
                    >
                      <div class="devImg">
                        <img :src="item.devImg" alt="" />
                      </div>
                      <div class="text">
                        <p>{{ item.devName }}</p>
                        <button @click="gotoDetail(item)">详情参数</button>
                      </div>
                    </div>
                  </div>

    
                </el-tab-pane>
              </el-tabs>
            </div> -->
          </div>

          <div class="Related_Products" v-if="this.Cindex == 1">
            <div id="Related_Products2" class="Related_Products22"></div>
            <div class="title">
              <span></span>
              <h2>软件产品</h2>
            </div>
            <div class="tabs">
              <ul>
                <li v-for="(item, index) in Software" :key="index">
                  <img
                    :src="item.proIcon"
                    width="100px"
                    height="100px"
                    alt="软件产品图标"
                    style="cursor: pointer"
                    @click="gotoSoftWareChengDetail(item)"
                  />
                  <p>{{ item.proName }}</p>
                </li>
              </ul>
            </div>

            <div class="title">
              <span></span>
              <h2>硬件产品</h2>
            </div>
            <div class="list">
              <!-- <img
                class="img1"
                @click="prev()"
                src="../assets/icon/left.png"
                alt=""
              />
              <img
                class="img2"
                @click="next()"
                src="../assets/icon/right.png"
                alt=""
              /> -->
              <div
                class="item"
                v-for="(item, index) in HardwareList"
                :key="index"
              >
                <div class="devImg">
                  <img :src="item.devImg" alt="硬件产品展示图" />
                </div>
                <div class="text">
                  <p>{{ item.devName }}</p>
                  <button @click="gotoDetail(item)">详情参数</button>
                </div>
              </div>
            </div>

            <!-- <div class="tabs">
              <el-tabs v-model="activeName" class="demo-tabs">
                <el-tab-pane label="软件产品" name="software">
                  <ul>
                    <li v-for="(item, index) in Software" :key="index">
                      <img
                        :src="item.proIcon"
                        width="100px"
                        height="100px"
                        alt=""
                      />
                      <p>{{ item.proName }}</p>
                    </li>
                  </ul>
                </el-tab-pane>
                <el-tab-pane label="硬件产品" name="hardware">

                  <div class="list">
                    <div
                      class="item"
                      v-for="(item, index) in hardware"
                      :key="index"
                    >
                      <div class="devImg">
                        <img :src="item.devImg" alt="" />
                      </div>
                      <div class="text">
                        <p>{{ item.devName }}</p>
                        <button @click="gotoDetail(item)">详情参数</button>
                      </div>
                    </div>
                  </div>

    
                </el-tab-pane>
              </el-tabs>
            </div> -->
          </div>

          <div class="Related_Products1" v-if="this.Cindex == 2">
            <div id="architecture4" class="architecture44"></div>
            <div class="title">
              <span></span>
              <h2>软件产品</h2>
            </div>
            <div class="tabs">
              <ul>
                <li v-for="(item, index) in Software" :key="index">
                  <img
                    :src="item.proIcon"
                    width="100px"
                    height="100px"
                    alt="软件产品图标"
                    style="cursor: pointer"
                    @click="gotoSoftWareNongDetail(item)"
                  />
                  <p>{{ item.proName }}</p>
                </li>
              </ul>
            </div>
            <div id="Hardware"></div>
            <div>
              <div class="title">
                <span></span>
                <h2>硬件产品</h2>
              </div>
              <div class="list">
                <div
                  class="item"
                  v-for="(item, index) in HardwareList"
                  :key="index"
                >
                  <div class="devImg">
                    <img :src="item.devImg" alt="硬件产品展示图" />
                  </div>
                  <div class="text">
                    <p>{{ item.devName }}</p>
                    <button @click="gotoDetail(item)">详情参数</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="tabs">
              <el-tabs v-model="activeName" class="demo-tabs">
                <el-tab-pane label="软件产品" name="software">
                  <ul>
                    <li v-for="(item, index) in Software" :key="index">
                      <img
                        :src="item.proIcon"
                        width="100px"
                        height="100px"
                        alt=""
                      />
                      <p>{{ item.proName }}</p>
                    </li>
                  </ul>
                </el-tab-pane>
                <el-tab-pane label="硬件产品" name="hardware">

                  <div class="list">
                    <div
                      class="item"
                      v-for="(item, index) in hardware"
                      :key="index"
                    >
                      <div class="devImg">
                        <img :src="item.devImg" alt="" />
                      </div>
                      <div class="text">
                        <p>{{ item.devName }}</p>
                        <button @click="gotoDetail(item)">详情参数</button>
                      </div>
                    </div>
                  </div>

    
                </el-tab-pane>
              </el-tabs>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      HardwareList: [],
      caseTabs: [
        {
          name: "智慧水利",
          imgURL: require("../assets/product/Water_affairs.jpg"),
          img: require("../assets/product/Water_affairs_HL.jpg"),
          bgIMG: require("../assets/case/case-tab-bg-01.jpg"),
        },
        {
          name: "智慧城管",
          imgURL: require("../assets/product/Urban_management.jpg"),
          img: require("../assets/product/Urban_management_HL.jpg"),
          bgIMG: require("../assets/case/case-tab-bg-02.jpg"),
        },
        {
          name: "智慧农业",
          imgURL: require("../assets/product/Agriculture.jpg"),
          img: require("../assets/product/Agriculture_HL.jpg"),
          bgIMG: require("../assets/case/case-tab-bg-03.jpg"),
        },
      ],
      Cindex: 0,
      Rid: 0,
      show: true,
      activeName: "software",
      bannerList: [],
      Software: [],
      hardware: [],
      pageNum: 1,
      pageSize: 4,
      total: 0,
      page: 0, //点击翻页数
      show1: false,
      queryId: 0,
      overview1:
        "旭瑞智能按照部、省水利(水务)信息化发展规划与要点，结合智慧城市建设总体要求，聚焦于政府监管、江河调度、工程运行、应急处置、高效便民等方面的业务需求，以水利数据共享和流程优化为重点，运用物联网、云计算、大数据、人工智能等新一代信息新技术，构建互联互通、信息共享及协同应用的“智慧水利综合管理平台”，推动水利综合业务精细化管理，提升科学化决策调度管理水平，为水利部门及相关企业日常业务和领导的决策指挥提供快速、准确的支持。",
      overview11:
        "2018年11月6日，习近平总书记在上海考察城市管理工作时指出“城市管理应该像绣花一样精细。一流城市要有一流治理，要注重在科学化、精细化、智能化上下功夫。既要善于运用现代科技手段实现智能化，又要通过绣花般的细心、耐心、巧心提高精细化水平，绣出城市的品质品牌。”实现城市又好又快地发展，就要在科学化、精细化、智能化上下功夫，既要用科学理念、科学方法进行城市治理，也要注重细节管理，提高精细化水平，更要利用技术手段，走智能化之路。",
      overview2:
        "旭瑞智能智慧水利综合管理平台通过对水利对象及水利管理活动进行透彻感知、网络互联、信息共享和智能分析，最终形成“更透彻的感知、更全面的互联互通、更科学的决策、更高效智能的管理”的智慧水利管理体系，为水利业务提供智能处理、决策支持和泛在服务。",
      overview22:
        "旭瑞智能“智慧城管”是在智慧城市的框架下，运用地理信息、物联网、云计算、人工智能等新技术，围绕城市管理监督和城市管理指挥两个轴心，通过对城市市政工程设施、市政公用设施、市容环境与环境秩序监督管理、城市应急管理的综合集成化管理，以及对海量数据的整合处理、挖掘分析与知识发现，再造城市管理流程，提高业务智能协同能力，打造实现城市管理信息的智能化收集、整理、融合，形成精确、敏捷、高效、全时段监控、全方位覆盖的新型城市管理模式。",
      overview23:
        "借助精准的农业传感器进行实时监测，利用科学技术手段进行多层次分析，智慧农业构建了集环境监控、精准调节为一体的农业生产系统，不仅可以有效提高农业生产对自然环境风险的应对能力，还可以对不同的农业生产环境及对象进行监测监管，通过传感设备检测环境的物理参数，对土壤、虫情、气象等生产环境状况进行实施动态监控，使之符合农业生产环境标准，这些新技术的应用将大大改善农产品品质，使其符合市场需求，实现供给与需求的有效对接，促进农业生产精细化、高效化、现代化发展。",
      overview3:
        "智慧水利综合管理平台采用物联网+混合云+大数据分析+专业模型算法等先进技术，以“1个中心+1个门户+1个平台” 为主要建设内容，致力服务于水旱灾害、水工程安全运行、水工程建设、水资源开发利用、江河管理、水利监管监督等全业务领域。",
      overview31:
        "智慧城管在建设的总体技术和管理思路上，确定以“三统一”作为总体指导原则，打造善于认识、专为理解、推理和学习的“智慧城市综合治理平台”，让平台像人类一样思考，能够帮助城市管理者在新环境下重新定义城市规划，推进城市治理制度、模式和手段创新，提高城市科学化、精细化、智能化管理水平。",
      overview32:
        "智慧农业综合管理平台是集灌溉、墒情、虫情、苗情、气象、孢子监测于一体的在线监控平台，采用先进的信息采集系统，以物联网、人工智能、大数据、互联网等技术为基础，用户可以通过PC端网页、APP客户端等多种渠道实现远程控制管理功能。用户可以实时对每个站点的气象环境、土壤墒情、作物生长及现场灾害情况、虫情、植物病害等影响作物生长的重要参数进行实时监测、管理，同时实现远程定时灌溉、自动灌溉及远程手动灌溉。",
      overview4:
        "智慧水利综合管理平台采用面向服务架构（SOA） 思想， 以云计算、物联网等技术为支撑、以水利信息化基础设施整合为先导，以水利信息资源共享为核心， 以水利业务应用推进为重点，以标准规范体系为指导， 以安全防护体系为保障，采用“分布多级、统一管理、集中服务”的总体架构模式，推进水利信息化的全面渗透，深度融合，将水利信息化提高到全新的水平。",
      overview41:
        "目前由旭瑞智能自主研发的智慧农业系统功能模块如下图，可根据客户需求增加其他功能或定制开发。",
      overview5:
        "旭瑞智能结合水利部门职责及业务需求，依托水利云数据中心，针对河湖长制、防汛抗旱、水资源管理、城市供排水管理、水政执法、水利工程建设管理、河湖水域划界确权管理、水库灌区信息化等方向，建设智慧水利综合管理平台，通过信息化手段全面提高管理人员业务能力，规范管理流程， 提高管理效率。",
      overview51:
        "智慧城市围绕着感知、分析、服务、指挥、监察“五位一体”的总体要求，依托物联感知建设和资源整合，实现部件状态的智慧感知，健全城市管理的“神经网络”，通过视频智能分析服务，实现事件违章的智慧发现、定位、跟踪和监管，借助物信融合数据平台，实现城市管理领域内各类数据的采集整合及入库，构建涵盖人、地、事、物、组织等多方位主题数据库。",
      overview52:
        "智慧城市通过各个应用系统的灵活构建，为城管不同的用户部门提供高效、清晰、智能的监管手段，让职能部门结合各自业务开展情况探索视频应用，有效提升整体业务监管水平能力，融合实现监督指挥、行政执法、建筑垃圾清运、市政设施监管等业务应用，强化标准化采集、科学化决策、智能化指挥和人性化服务能力。",
      overview6:
        "智慧城管是现代城市管理思想、管理理念、管理技术和管理体制的整合与创新，依托物联感知建设和资源整合，以城市公用设施为突破口，逐步推进市政、环卫、执法、园林等公共设施智慧化运营监管，充分发挥城市运行管理平台在城区防汛排涝、流动摊贩治理、餐饮油烟整治、城市治安、违法建筑、消防、环保等重点行动中的基础保障作用，为应急指挥、领导决策、公众参与提供服务，让城市管理既高效又有温度。",
      overview7:
        "智慧农业解决方案是一种基于物联网、移动互联网、云计算等技术而搭建的农业智能环境监控系统与农业智能化、标准化生产服务平台，旨在帮助用户构建起一个智慧灌溉、水利交易管理系统、水肥一体化的农业智能化信息服务体系，为用户带来一站式的智慧农业全新体验，让灌溉施肥更智能，让种植更科学。",
    };
  },
  updated() {
    if (this.$route.query.name) {
      this.$el.querySelector(this.$route.query.name).scrollIntoView();
    }
  },
  created() {
  
    console.log(this.$store.state.num, "vuex");
    this.rotation();
    // this.autocades(this.Cindex);
    this.hardwares();
    this.getHardware();
    this.Software = [
      {
        proId: 1,
        proType: 1,
        proName: "智慧水利-大数据可视化",
        proIcon:
          "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧城管/大数据可视化展示2.png",
        proImg: "http://hkimg.xuruidea.com/web_img/cmp_website/yangxin.png",
        proContent:
          '<h4 style="text-align:left;"><br/></h4><h4 style="text-align:left;"><!--[if-->一、<!--[endif]-->系统介绍</h4><p style="text-align:left;"><span style="text-align: left;">智慧水利大数据可视化系统通过水位计、流量计、闸位计、水质传感器等传感设备在线采集、监测水利设施运行状态，直观展示水位、雨量、水量、水质、工情、旱情、灾情等重点管理对象的实时数据，实现水利管理综合运营态势一屏掌握，</span>达到全域数据的可视、可管、可控，具备系统智能化、数据资源化、管理精确化的优势，保证水利设施运行安全，水利运营更高效和科学管理。<br/></p><p>水利系统监测至关重要，通过大数据可视化系统，运维管理人员能够直观、高效、准确、具体的获取一手资料，分析水利实时的运行状态，掌握水利实时的工作形态，评价水利实时的安全状况，为发现水利实时异常提供依据。</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/11657261446887.png" style="max-width:100%;" contenteditable="false"/></p><h4 style="text-align:left;"><br/></h4><h4 style="text-align:left;">二、系统功能<br/></h4><p style="text-align:left;">1、运用数据模型，集中精准展示各功能模块及各要素的重要数据、趋势分析、预警信息等，实现大数据动态化、真实化、实时化、趋势化、预警化；</p><p style="text-align:left;">2、具备子系统关键监管数据的实时展示功能，可视化展示所选区域及其子区域的资源运行情况，包括各子系统不同模块站点的设备总数、在线率等；</p><p style="text-align:left;">3、以折线图、柱状图、滚动窗等方式进行数据的动态展示，例如水情监测模块24小时水位折线图、雨情监测模块24小时降雨量折线图、积水点监测模块电子尺一周数据折线图、水位报警信息轮播等；</p><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;">4、通过对辖区水利各项数据及处置情况的实时直观展示，为领导决策及调度指挥提供精准的数据支撑。</p>',
        proSort: 1,
        proIsShow: 1,
        createTime: "2022-05-25 09:58:08",
        languageType: 1,
      },
      {
        proId: 21,
        proType: 1,
        proName: "智慧水利-GIS一张图",
        proIcon:
          "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧城管/GPS一张图3.png",
        proImg: null,
        proContent:
          '<h4></h4><h4 style="text-align:left;"><br/></h4><h4 style="text-align:left;">一、系统概述</h4><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/21657260088581.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;">智慧水利GIS系统综合运用基础地理数据、水利基础数据和水利业务数据，以不同标识在带有位置坐标的地图上集中展现闸泵监控站点、测流点、雨量站、河道水位站、积水点等分布情况，并直观展示监测点位置、名称、运行状态及实时监测数据，从而实现对水利设施最完整、最彻底的管理与分析，为水利业务应用系统的快速搭建提供数据支撑。<br/></p><p style="text-align:left;">同时，该系统在GIS地图的基础上，嵌入应急事件预警模块和指挥调度模块，构成了具有扁平化、可视化、精准化指挥调度能力的“一张图”，进而实现了分析、监控、指挥、调度一体化的全域应急管理。当设备状态及通讯异常或监测数据超标时，将以图标变色闪动及文字报表形式进行自动报警，不仅节约了大量的人力物力，降低了巡检成本，而且缩短了监测时间，实现了水利设施监测的自动化、实时化、高效化。</p><p><br/></p><h4 style="text-align:left;"></h4><h4 style="text-align:left;">二、系统功能</h4><p style="text-align:left;">1、应用GIS技术与实时数据相结合，实现集智慧水利管理中所有关键监管要素于一体的一张图展示、调度</p><p style="text-align:left;">2、一张图功能模块按照设备类型、展现类型、业务类型，以不同标识展现闸泵监控站点、测流点、雨量站、河道水位站、积水点等信息，并可根据搜索需求，对设备类型、业务类型及区域进行选择性展示；</p><p style="text-align:left;">3、一张图上的标识点具备图层展示概要信息、穿透查看详情信息等功能，通过地图可直观、快速掌握各站点分布情况及站点数据的实时动态信息；</p><p style="text-align:left;">4、通过GIS地图可实现监测终端报警信息的动态显示，使水情、雨情监测预警的操作与应用更加便捷直观；</p><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;">5、可实现视频信息的实时调取，达到指挥调度的功能。</p>',
        proSort: 2,
        proIsShow: 1,
        createTime: "2022-05-25 09:58:08",
        languageType: 1,
      },
      {
        proId: 22,
        proType: 1,
        proName: "无人值守远程控制系统",
        proIcon:
          "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/无人值守远程控制系统3.png",
        proImg: null,
        proContent:
          '<p><b></b></p><p style="text-align:left;"><b><br/></b></p><p style="text-align:left;"><b>一、方案背景</b></p><p style="text-align:left;">随着我国科技水平和综合国力的大力提高，水利资源在国民经济建设中体现出越来越重要的地位。近几十年来，国家投入巨资，沿各大流域及其它主要河流、湖泊修建了堤防、涵闸和泵站，在山区和丘陵地区兴建拦洪、发电和灌溉工程，在无自流条件的易涝和干旱地区兴建泵站除涝抗旱。</p><p style="text-align:left;">同时，随着水利工程的大量兴建，由于我国水利设施点多、面广、量大所带来的弊端也逐渐显露出来。若采用人工值守的方式，需要多名工作人员24小时轮流值班，不仅管理成本极高，而且管理效果极差。</p><p style="text-align:left;">针对目前水利工程在实际运行过程中遇到的问题，我司自主研发的“无人值守远程智能控制系统”，便很好的解决了水利设施无人值守、远程控制、无市电供应等难题。</p><p><br/></p><p style="text-align:left;"><b>二、系统概述</b></p><p style="text-align:left;">旭瑞智能无人值守远程智能控制系统是基于我司自主研发的智能控制柜和智慧水利综合管理平台，融合物联网、远程智能控制、远程数据采集、智能传感、云计算、大数据、移动互联网等前沿技术，对江河湖泊、水资源、水利工程、防汛抗旱、水文信息、水库安全、农田灌溉与节水以及各类涉水主体进行数字化、网格化、智能化管理，极大提高了水利的信息化、智能化建设和工作效率，减少了人力、物力、财力消耗，使水利设施的管理更便捷、高效、人性化、智慧化，构建出“自然和谐共生”的智慧水利新格局。</p><p><br/></p><p style="text-align:left;"><a><b></b></a></p><p style="text-align:left;"><b>三、硬件</b><b>产品</b></p><p style="text-align:left;"><b>1</b><b>、智慧水利控制器</b></p><img src="http://files.xuruidea.com/0/20220630/image1656574318568.png" style="max-width:100%; text-align:left;" contenteditable="false"/><p style="text-align:left;"><span style="font-size: 14px;">&nbsp;</span><b>① 产品功能</b></p><p>支持远程智能控制（可远程或现场精准控制闸泵的启停及升降）、远程数据采集、各种水文气象传感设备及供电信息等数据的接入、视频监控流媒体传输限流自控功能、现场校准、本地WEB升级程序、远程升级程序、远程修改设备IP端口、远程重启设备、本地USB查看设备日志/本地USB升级。</p><p style="text-align:left;"><b>② 技术参数</b></p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->超低功耗：DC8-36V宽电压供电，电流≤500mA，超高电压自动断电保护，防电源反接，防浪涌，ESD防静电等保护；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->RS232接口：标准RS232通讯接口；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->RS485接口：最大设备节点255个；支持2路RS485，1路RS232，1路以太网，4路模拟量采集，4路数字量采集；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->GPRS传输：支持全网通3G/4G/5G传输；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->以太网接口：10MB/100MB自适应；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->编码器接口：支持多种编码器的接入；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->RJ-45网口防雷保护，全金属外壳保护等级IP30，软硬件双重看门狗防死机设计。</p><p style="text-align:left;">③&nbsp;<b>应用场景</b>：节制闸、泵站、橡胶坝、翻板闸、钢板闸等智慧水利（务）行业。</p><p><br/></p><p style="text-align:left;"><b></b></p><p style="text-align:left;"><b>2</b><b>、智慧水利控制柜</b></p><p style="text-align:left;"><b></b></p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/11657260655748.jpg" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b></b></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;">&nbsp;</span><b>① 产品特点</b></p><p style="text-align:left;">集成远程控制、雨情遥测、水文气象信息、供电信息、无线传输、水利设施安防预警信息采集等功能端口，也可根据需求定制开发。</p><p style="text-align:left;"><b>② 技术参数</b></p><p style="text-align:left;"><span style="text-align: center;">●&nbsp;&nbsp;</span><b>智慧水利控制柜：</b>双层防水防尘设计；含闸位信息采集终端、闸门专用控制单元、电压电流采集终端、无线传输终端（不含物联网卡）、继电器、断路器、端子、线缆等辅材（不含动力电缆）；具有急停保护功能；1台控制柜可同时控制5孔闸；</p><p style="text-align:left;"><span style="text-align: center;">●</span>&nbsp;&nbsp;<b>人机交互界面：</b>10"液晶触摸屏，12V供电，分辨率：800*600；</p><p style="text-align:left;"><span style="text-align: center;">●</span>&nbsp;&nbsp;<b>智能控制器：</b>可远程或现场精准控制闸泵的启停及升降；支持现场校准；支持全网通4G/5G通讯；支持本地WEB升级程序；支持远程升级程序；超低功耗：DC8-36V宽电压供电，电流≤500mA，超高电压自动断电保护，防电源反接，防浪涌，ESD防静电等保护；RJ-45网口防雷保护，全金属外壳保护等级IP30，软硬件双重看门狗防死机设计；远程修改设备IP端口，远程重启设备，远程升级；本地USB查看设备日志，本地USB升级；标准RS232通讯接口；RS485接口：最大设备节点255个；支持2路RS485，1路RS232，1路以太网，4路模拟量采集，4路数字量采集；支持多种编码器的接入；GPRS传输；以太网接口：10MB/100MB自适应；支持各种水文气象传感设备及供电信息等数据的接入；具有视频监控流媒体传输限流自控功能。</p><p style="text-align:left;"><span style="text-align: center;">●</span>&nbsp;&nbsp;设备运行时具有对静电放电、电快速瞬变脉冲群、浪涌（冲击）的抗扰度。</p><p style="text-align:left;"><b>③ 应用场景：</b>可应用于节制闸、泵站、橡胶坝、翻板闸、钢板闸等智慧水利（务）行业。</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220630/image1656574514552.png" style="max-width:100%;" contenteditable="false"/>\n<b></b></p><p style="text-align:left;"><b><br/></b></p><p style="text-align:left;"><b>三、系统功能</b></p><p style="text-align:left;">无人值守远程智能控制系统具有大数据可视化、GIS一张图、闸泵无人值守远程控制、视频监控总览、系统设置、用户权限、操作日志等功能模块，并可扩展自动水位站、自动流量站、雨情遥测、水利设施安防预警、灌区节水、山洪预警等功能模块。</p><p style="text-align:left;"><b>1.&nbsp;&nbsp; </b><b>大数据可视化展示</b></p><p style="text-align:left;">基于业务及GIS等引擎，集中精准展示节制闸、泵站等模块的重要数据、趋势分析、预警信息等，实现大数据动态化、真实化、实时化、趋势化、预警化，为领导决策及调度指挥提供了精准的数据支撑。</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/11657262269535.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>2.&nbsp;&nbsp;\n</b><b>GIS</b><b>地图展示</b></p><p style="text-align:left;">应用GIS技术与实时数据相结合，直观显示各节制闸、泵站的分布位置、供电信息、设备运行情况等关键监管要素，帮助管理人员快速掌握各站点分布情况及站点数据的实时动态信息。</p><p style="text-align:center;"><br/><img src="http://files.xuruidea.com/0/20220708/31657262296581.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>3.&nbsp;&nbsp; </b><b>拦河闸管理</b></p><p style="text-align:left;">通过现场各传感设备及视频监控的实时数据采集和上传等功能，实现拦河闸站内设备运行情况的实时观测，为领导决策提供直观的图像信息，并通过现场人工操作、后台管理软件或手机APP对拦河闸水利设施进行远程精准控制，实现闸门开启高度的设定、闸门的关闭与设备的暂停等功能，有效减少了人力物力，达到无人值守的目的。</p><p style="text-align:left;">同时，系统具备水位超高自动报警功能，当河道水位达到警戒水位时，远程控制平台软件可自动发出警报信息至管理员的手机，提醒工作人员进行紧急处理，最大程度地减少危害和影响。</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/41657262365890.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>4.&nbsp;&nbsp; </b><b>泵站管理</b></p><p style="text-align:left;">通过前端泵站的视频监控，可实现泵站设备运行情况的实时观测，为领导决策提供直观的图像信息，减少人力物力；并通过后台管理软件或手机APP对泵站等水利设施进行远程精准控制，包括远程开启、关闭、暂停等。</p><p style="text-align:left;">同时，通过现场各传感设备实时的数据采集和上传等功能，实现泵站瞬间流量、累计水量、水位、流速、灌溉面积、设备状态等动态实时信息的展示与调取，为领导决策提供数据依据。<b></b></p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/51657262408909.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>5.&nbsp;&nbsp; </b><b>查询管理</b></p><p style="text-align:left;">提供了泵站、闸门、视频设备的查询功能，工作人员通过查询条件的筛选可直接对各个泵站、闸门、视频设备数据或者某个时间段内的设备信息进行查询，实现所属资源的信息化与可视化管理，为资源的管理与配置、扩容与维护、决策与调度提供更直观、更精准的数据支撑。</p><p><img src="http://files.xuruidea.com/0/20220708/61657262511299.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>6.&nbsp;&nbsp; </b><b>系统管理</b></p><p style="text-align:left;">具有权限管理、用户管理和角色管理三种功能：权限管理可针对不同用户的工作需要，进行权限设定和管理；用户管理包括用户名称、所属角色、联系电话等信息的记录，并具备用户的新增与删除功能；角色管理主要是根据用户的职务、管理范围自定义设置多级管理权限及角色，可编辑修改用户的使用状态，可以对用户权限进行编辑和删除，提高系统管理与使用的安全级别。</p><p><img src="http://files.xuruidea.com/0/20220708/71657262545952.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>7.&nbsp;&nbsp; </b><b>操作日志</b></p><p style="text-align:left;">对系统操作者的每一次操作进行记录、统计和查询展示，包括操作时间、操作人姓名、所属角色、操作模块名称、操作具体内容等，提高软件系统运行与操作的安全级别，实现异常操作的有据可查及追责取证。</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/微信截图_202207081442421657262577287.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>8.&nbsp;&nbsp; </b><b>手机APP</b></p><p style="text-align:left;">无人值守远程控制App，运用数字化、信息化、智能化手段提升闸泵预警管理效能，以闸门、泵站管理功能模板为主，支持短信预测、报警记录、数据统计分析、报警信息等等功能；可根据权限定时推送当日工作情况，自动分析汇总生成工作报表；并对各类关键指标，以动态图表、文字、仪表盘的形式直观展示，方便管理人员随时查看并处理，有效提升了行政效能，使无人值守远程控制管理工作更简单、便捷、高效。&nbsp;&nbsp;</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/图片11657260986795.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b></b></p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/图片41657261023545.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;"><br/></span></p><p style="text-align:left;"><b>四、案例展示</b></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657520882344.png" contenteditable="false" style="font-size: 14px; max-width: 100%;"/>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 节制闸（单孔）&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;节制闸（双孔）</p><img src="http://files.xuruidea.com/0/20220711/991657521080118.png" style="max-width:100%;" contenteditable="false"/><span style="font-size: 16px; text-align: center;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 橡胶坝</span><div><span style="font-size: 16px;"><br/><br/></span></div><div><span style="font-size: 16px;"><br/></span></div>',
        proSort: 3,
        proIsShow: 1,
        createTime: "2022-05-25 09:58:08",
        languageType: 1,
      },
      {
        proId: 23,
        proType: 1,
        proName: "雨情自动遥测系统",
        proIcon:
          "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/雨情自动遥测系统3.png",
        proImg: null,
        proContent:
          '<p><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a></p><p style="text-align:left;"><font color="#000000"><br/></font></p><p style="text-align:left;"><b><font size="4" color="#000000">一、方案背景</font></b></p><p style="text-align:left;"><font color="#000000">每年4到10月份都是我国的汛期，水旱灾害防御形势日趋紧张。在汛期，防汛抗洪一直都是重中之重，降雨量增大所引发的洪涝灾害严重影响到了人民的生命财产安全。近几年来，国家一直呼吁各省市地区汛期做好洪涝灾害的防御<a href="http://baike.eastmoney.com/item/%E5%B7%A5%E4%BD%9C" target="http://finance.eastmoney.com/a/_blank"><font color="#000000">工作</font><span></span><span></span></a>，第一时间掌握雨情数据也就掌握了防汛抗洪的主动权，最大程度避免洪涝灾害的发生。</font></p><p style="text-align:left;"><font color="#000000">雨情实时变化难以预测，不同区域降雨量有很大差异，如果依靠传统人力大范围观察降雨量非常被动。我司自主研发的雨情自动遥测系统可以提供全方位的雨情数据，能够让工作人员第一时间了解到大范围内雨情的实时变化，在节省人力物力的同时提高数据的准确性。</font></p><p style="text-align:left;"><font color="#000000"><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a></font></p><p style="text-align:left;"><b><font color="#000000"><br/></font></b></p><p style="text-align:left;"><b><font size="4" color="#000000">二、系统概述</font></b></p><p style="text-align:left;"><font color="#000000">雨情自动遥测系统是基于GIS地图开发，集信息采集、传输、分析和预警等多功能于一体，能够在线显示、统计、上传降雨量的自动化遥测平台，实时采集降雨量数据，在不同区域分别显示降雨量情况。</font></p><p style="text-align:left;"><font color="#000000">该系统采用软硬件结合方式，目标地点放置自动雨量站实时监测雨量数据</font><span style="color: rgb(0, 0, 0);">，再由无线网络(GPRS、CDMA)传输到管理者的电脑WEB端或手机app上，能够让管理者第一时间了解到雨情的变化；系统具有定时自报功能，定时报送水文数据。在监测到雨情流量超过预设值（自行设置预设值）时系统会自动向管理者电脑网页发送报警信息，以便管理者第一时间处理警情；系统的硬件平台采用双供电方式，内置有高性能电池。</span></p><p style="text-align:left;"><font color="#000000">使用者可以在电脑WEB端查看历史雨情数据、设备分布图、降雨统计以及雨量监测数据。该系统集成信息的汇集、处理、应用、分析、发布以及后续处理工作。广泛应用于防汛、气象、城市排涝等工作。通过平台，可实现雨情的实时预警，以保证水库、渠道及建筑物的安全；根据雨情分析灌区需水量和来水量，实现水量的科学配置；依靠暴雨时的雨情监测，为区域的防汛排洪提供辅助决策依据。</font></p><p style="text-align:left;"><font color="#000000"><br/><img src="http://files.xuruidea.com/0/20220630/image1656576993405.png" width="100%"/><br/><!--[endif]--></font></p><p style="text-align:left;"><b><a><font color="#000000"><br/></font></a></b></p><p><font color="#000000"><b><font size="4">三、硬件产品</font></b></font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577018872.png" style="font-size: 14px; max-width: 100%;" width="100%" contenteditable="false"/><b><font color="#000000"><!--[endif]--></font></b></p><p style="text-align:left;"><!--[if--><font color="#000000">①　<!--[endif]-->可外接雨量传感器；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">②　<!--[endif]-->4G、CDMA任意两种信道相连的接口；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">③　<!--[endif]-->具有定时自报和响应召测兼容的工作体制；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">④　<!--[endif]-->具备主备信道切换、发送确认、自动补发功能；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">⑤　<!--[endif]-->具备电源检测与管理、报警功能；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">⑥　<!--[endif]-->具备防盗开关信号接入与检测功能；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">⑦　<!--[endif]-->具备数据保护不丢失功能；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">⑧　<!--[endif]-->具备自检自诊断功能，死机自动复位；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">⑨　<!--[endif]-->具备自动同步时钟功能。</font></p><p style="text-align:left;"><b><font color="#000000"><br/></font></b></p><p style="text-align:left;"><b><font size="4" color="#000000">四、系统功能</font></b></p><p style="text-align:left;"><font size="3"><b><span style="color: rgb(0, 0, 0);">1</span><span style="color: rgb(0, 0, 0);">、GIS地图展示</span></b></font></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">基于GIS地图开发并集中显示各遥测雨量站的分布位置（按经纬度）、降雨量数据等，同时根据降雨量级对雨量站进行颜色标注，方便工作人员快速掌握各站点的雨量信息，并及时做出决策。</span></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220708/101657264981427.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">2、</span><b style="color: rgb(0, 0, 0);">雨情监测管理</b></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">通过点击站点图标，可实现降雨状态、当前降雨起始时间、降雨时长、当前累计降雨量、实时水位等动态实时信息的展示与调取。同时，通过监测终端报警功能，实现全方位、全天候、全时段雨量超标实时报警，并以短信和APP通知形式发送至相关管理人员，实现自动预警、自动防控功能。</span></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220708/91657262700933.png" style="max-width:100%;" width="100%" contenteditable="false"/></p><p style="text-align:left;"><b style="color: rgb(0, 0, 0);">3</b><b style="color: rgb(0, 0, 0);">、雨情分析管理</b></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">系统通过24小时降雨量统计折线图、雨情月报表以及雨情年报表，帮助管理人员迅速掌握雨量变化信息，提前做好防控准备，并为后期决策提供数据支持。同时，系统提供了雨情查询功能，管理人员通过搜索栏可直接查询各雨量站或者某天、某月、某年的雨情信息。</span></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220708/111657265043413.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b style="color: rgb(0, 0, 0);">4</b><b style="color: rgb(0, 0, 0);">、系统管理</b></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">具有权限管理、用户管理和角色管理三种功能：权限管理可针对不同用户的工作需要，进行权限设定和管理；用户管理包括用户名称、所属角色、联系电话等信息的记录，并具备用户的新增与删除功能；角色管理主要是根据用户的职务、管理范围自定义设置多级管理权限及角色，可编辑修改用户的使用状态，可以对用户权限进行编辑和删除，提高系统管理与使用的安全级别。</span></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220708/121657265079310.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b style="color: rgb(0, 0, 0);">5</b><b style="color: rgb(0, 0, 0);">、操作日志</b></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">对系统操作者的每一次操作进行记录、统计和查询展示，包括操作时间、操作人姓名、所属角色、操作模块名称、操作具体内容等，提高软件系统运行与操作的安全级别，实现异常操作的有据可查及追责取证。</span></p><p><img src="http://files.xuruidea.com/0/20220708/131657265110522.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b style="color: rgb(0, 0, 0);">6</b><b style="color: rgb(0, 0, 0);">、手机APP</b></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">雨情自动遥测App，运用数字化、信息化、智能化手段提升雨情预警管理效能，支持短信预测、报警记录、数据统计分析、报警信息等等功能；可根据权限定时推送当日工作情况，自动分析汇总生成工作报表；并对各类关键指标，以动态图表、文字、仪表盘的形式直观展示，方便管理人员随时查看并处理，有效提升了行政效能，使无人值守远程控制管理工作更简单、便捷、高效。</span></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);"><br/></span></p><p style="text-align:left;"><font color="#000000"><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a></font></p><p style="text-align:left;"><b><font size="4" color="#000000">五、案例展示</font></b></p><p><font color="#000000">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</font></p><p>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p><img src="http://files.xuruidea.com/0/20220630/image1656577181985.png" style="font-size: 14px; max-width: 100%;" width="100%" contenteditable="false"/><!--[endif]--><!--[endif]--></p><br/>',
        proSort: 4,
        proIsShow: 1,
        createTime: "2022-05-25 09:58:08",
        languageType: 1,
      },
      {
        proId: 24,
        proType: 1,
        proName: "自动水位站监测系统",
        proIcon:
          "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/自动水位监测系统3.png",
        proImg: null,
        proContent:
          '<p><a></a></p><p style="text-align:left;"><font color="#000000"><br/></font></p><p style="text-align:left;"><b><font color="#000000">一、方案背景</font></b></p><p style="text-align:left;"><font color="#000000">近几年随着环境的持续恶化，各种自然灾害频繁发生，尤其是水灾的发生给我国带来了巨大的经济损失和人员伤亡。汛期来临时，及时获得河道水库的水位涨幅数据对开展防汛抗洪工作至关重要，大量河道水库分布在远离城市的区域，而且分散，尤其是在紧急防汛阶段，如果只依靠传统人力巡查获得河道水位数据必将耗费大量人力物力。</font></p><p style="text-align:left;"><font color="#000000">我公司的智慧水利河道自动水位站监测预警系统可以为用户提供专业全面的水位监测控制管理，由水位传感器监测到水位的实时变化，将数据传递给管理者WEB端或手机APP。相比于传统水位站，具有快速查看数据、超限自动报警、自动记录上传等优点，使用者无须到达水位站，在电脑或手机就可以查看到详细数据，方便快捷又准确。</font></p><p style="text-align:left;"><font color="#000000"><br/></font></p><p style="text-align:left;"><font color="#000000"><a></a></font></p><p style="text-align:left;"><b><font color="#000000">二、系统概述</font></b></p><p style="text-align:left;"><font color="#000000">河道自动水位监测预警系统通过雷达或压力式水位传感器来感知水位变化，集太阳能供电、视频监控和无线传输设备于一体，具有水位采集、超限报警、自动记录上传、低电量报警、站点档案查看等功能，实时监测到的水位数据会通过GPRS、4G(移动、联通、电信）信号传输到独立的云服务器，再由云服务器平台将数据发送到使用者的电脑WEB端或手机APP上，便于水利或城市管理部门监测流域的实时水位、天气等数据。</font></p><p style="text-align:left;"><font color="#000000">河流水位监测预警系统是实时掌握河道水情变化，科学预警洪涝灾害、提升防汛指挥能力、降低雨洪灾害损失的重要手段，实现了对河流的信息化管理，很大程度避免了水位过高导致河流决堤的危险发生，在保护人民生命、财产安全方面发挥了重大作用。</font></p><p style="text-align:left;"><font color="#000000"><br/></font></p><p style="text-align:left;"><font color="#000000"><b></b></font></p><p style="text-align:left;"><b><font color="#000000">三、硬件产品</font></b></p><p style="text-align:left;"><font color="#000000">自动水位监测预警系统由雷达或压力式水位传感器来感知水位变化，集太阳能供电、视频监控和无线传输设备于一体，具有水位采集、趋势分析、超限报警、自动记录上传、低电量报警、站点档案查看等功能；实时监测到的水位数据会通过GPRS、4G/5G(支持全网通）信号传输到使用者的电脑WEB端或手机APP上，便于水利或城市管理部门监测流域的实时水位、天气等数据。</font></p><img src="http://files.xuruidea.com/0/20220630/image1656577287290.png" style="max-width:100%; text-align:left;" contenteditable="false"/><font style="text-align:left;" color="#000000"><br style="text-align:left;"/></font><p style="text-align:left;"><font color="#000000"><b>1、</b><b>雷达水位计</b></font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;测量范围：30米/70米可选；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;过程连接：螺纹G1½ʺ A / 支架/法兰；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;过程温度：-40～100℃；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;过程压力：常压；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;精度：±2mm；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;频率范围：26GHz；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;防护等级：IP67 ；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;供电电源： DC（6—24V）/四线；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;信号输出：RS485/Modbus 协议。</font></p><p style="text-align:left;"><font color="#000000"><b>2、</b><b>遥测终端机</b></font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;支持全网通；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;具有定时自报和响应召测兼容的工作体制；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;具备主备信道切换、发送确认、自动补发功能；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp; 具备电源检测与管理、报警功能；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;具备数据保护不丢失功能；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;具备自建自诊断功能，死机自动复位；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp; 具备自动同步时钟功能。</font></p><p style="text-align:left;"><font color="#000000"><b>3、</b><b>视频监控</b></font></p><p style="text-align:left;"><font color="#000000">高清智能球，实时监控河流区域画面，采集的监控数据自动上传到云平台，用户通过电脑或手机端对河道水位、水情进行远程查看。</font></p><p style="text-align:left;"><font color="#000000"><b>4、</b><b>水位监测杆</b></font></p><p style="text-align:left;"><font color="#000000">采用优质钢材，顶端用盖板封闭，底部配置检修口；整体进行防锈、防腐蚀处理；抗风等级9级。</font></p><p style="text-align:left;"><font color="#000000"><b>5、</b><b>太阳能发电</b></font></p><p style="text-align:left;"><font color="#000000">由蓄电池、太阳能板、充电控制器、信号避雷器、支架等组成。</font></p><p style="text-align:left;"><font color="#000000"><b></b></font></p><p style="text-align:left;"><b><font color="#000000"><br/></font></b></p><p style="text-align:left;"><b><font color="#000000">四、系统功能</font></b></p><p style="text-align:left;"><font color="#000000"><b>1</b><b>、GIS地图展示</b></font></p><p style="text-align:left;"><font color="#000000">系统运用物联网感知手段实时采集河道水位、流量等数据信息，并通过GIS地图直观展示各河道水位监测站的分布位置、水位信息、设备状态、电池状态等。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577307652.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>2</b><b>、防汛指挥模式</b></font></p><p style="text-align:left;"><font color="#000000">当有汛情时，可切换至此模式，界面集中展示报警水位站的实时水位情况，可任意调取水位站的实时监控图像，并参照实时的天气预报信息，可对汛情做出及时的决策和处置方案，使报警与指挥融为一体，让防汛工作的开展更精准、更具有时效性。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577316174.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>3</b><b>、水位实时数据</b></font></p><p style="text-align:left;"><font color="#000000">实时显示各水位站的水位、瞬时流量、流速、警戒水位等水文信息，以及各水位站的水位小时变化曲线图。并通过提供360度现场监控图像，实现水位信息的动态实时展示与调取。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577324430.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>4</b><b>、报警管理</b></font></p><p style="text-align:left;"><font color="#000000">当水位高于警戒水位时，系统会通过手机短信、平台预警、APP预警等多种提示方式发送至管理人员手机，责任人根据情况可及时采取应对措施并上传预警处置记录。通过监测终端报警，实现了城市防汛的自动预警、自动防控功能。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577331329.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>5</b><b>、设备管理</b></font></p><p style="text-align:left;"><font color="#000000">将GIS技术与实时数据相结合，对资源数据和信息进行采集、储存、管理、显示和描述，包括水位设备的状态及点位分布，太阳能设备的数量、电量、状态及站点信息，监控设备的数量、点位及监控状态等，实现所属资源的信息化与可视化管理，为资源的管理与配置、扩容与维护、决策与调度提供更直观、更精准的数据支撑。</font></p><p style="text-align:left;"><font color="#000000">同时通过平台，可对站点及设备信息进行管理，包括站点及设备的新增、修改、删除，以及水位警戒值的设定等。</font></p><img src="http://files.xuruidea.com/0/20220630/image1656577338666.png" style="max-width:100%; text-align:left;" contenteditable="false"/><p style="text-align:left;"><font color="#000000"><b>6</b><b>、系统管理</b></font></p><p style="text-align:left;"><font color="#000000">具有组织结构、用户管理和角色管理三种功能：组织结构可对组织名称、地址进行编辑管理；用户管理包括用户名称、所属角色、联系电话等，可实现用户的新增、编辑、修改和删除；角色管理主要是根据用户的职务、管理范围自定义设置多级管理权限及角色，可编辑修改用户的使用状态，可以对用户权限进行编辑和删除，提高系统管理与使用的安全级别。</font></p><img src="http://files.xuruidea.com/0/20220630/image1656577346621.png" style="max-width:100%; text-align:left;" contenteditable="false"/><p style="text-align:left;"><font color="#000000"><b>7</b><b>、操作日志</b></font></p><p style="text-align:left;"><font color="#000000">对系统操作者的每一次操作进行记录、统计和查询展示，包括操作时间、操作人姓名、所属角色、操作模块名称、操作具体内容等，提高软件系统运行与操作的安全级别，实现异常操作的有据可查及追责取证。</font></p><p style="text-align:left;">&nbsp;&nbsp;<img src="http://files.xuruidea.com/0/20220630/image1656577353068.png" style="max-width:100%;" contenteditable="false"/>&nbsp;<!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>8</b><b>、手机APP</b></font></p><p style="text-align:left;"><font color="#000000">自动水位站监测App，运用数字化、信息化、智能化手段提升城市防汛监测预警管理效能，以水位站管理功能模板为主，支持短信预测、报警记录、数据统计分析、报警信息等等功能；可根据权限定时推送当日工作情况，自动分析汇总生成工作报表；并对各类关键指标，以动态图表、文字、仪表盘的形式直观展示，方便管理人员随时查看并处理，有效提升了行政效能，使城市防汛管理工作更简单、便捷、高效。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577362335.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><a><font color="#000000"><br/></font></a></p><p style="text-align:left;"><a><font color="#000000"><b>五、案例展示</b></font></a></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577372983.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;"><font color="#000000">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <font face="楷体">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;河道水位站</font></font></p>',
        proSort: 5,
        proIsShow: 1,
        createTime: "2022-05-25 09:58:08",
        languageType: 1,
      },
      {
        proId: 25,
        proType: 1,
        proName: "自动流量站监测系统",
        proIcon:
          "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/自动流量站监测系统3.png",
        proImg: null,
        proContent:
          '<h1 style="text-align:left;"><font color="#000000"><b style="font-size: 16px;">一、方案背景</b><br/></font></h1><p style="text-align:left;"><font color="#000000">传统的水文测验是一直沿用测深杆或测绳测深，起点距标志牌定位，流速仪或浮标测速，手工计算。测流量前首先需要施测各测点流速，最后计算出断面流量。人工记数与计算很容易出错，而且测流准备工作繁琐，耗费人力资源量大，测流速度慢，功效低。随着最严格水资源管理制度的落实，对区域出入境水量统一调度要求越来越高。为适应新时期水文测报快速、准确、精度高、任务多的要求，旭瑞智能自主研发的自动测流站监测系统，较好的解决了这一问题。</font></p><p><font color="#000000"><br/></font></p><h4 style="text-align:left;"></h4><h4 style="text-align:left;"><font color="#000000">二、方案概述</font></h4><p style="text-align:left;"><font color="#000000">自动流量站监测系统是用来监测河道水文流量的平台，可以有效对河道流速、水位、瞬间流量、累计流量等数据进行实时监测和统计， 如有险情，第一时间采取应对措施，为保障流域内适度蓄水和安全度汛提供了准确、及时的现场信息，能够真正做到防灾减灾、水情预警等大数据应用需求，对防洪减灾工作的有序进行具有重大意义。</font></p><p style="text-align:left;"><font color="#000000">通过现场各种探测器，将探测到的水流速、瞬时流量、水位、累计流量、视频图像或图片等数字化信息，通过4G/5G通道上传到在线监测监视中心。系统可以实时监测流量状况，可以提供在线数据查询及统计分析，能够为河道水文流量的监测和管理提供数据分析和决策依据，并为河道治理提供丰富的数据支持。</font></p><h4 style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577465510.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></h4><h4 style="text-align:left;"><font color="#000000"><br/></font></h4><h4 style="text-align:left;"><font color="#000000">三、系统功能</font></h4><p style="text-align:left;"><font color="#000000"><b>1</b><b>、GIS地图展示</b></font></p><p style="text-align:left;"><font color="#000000">通过GIS地图，集中展示测流点的具体位置及分布情况，并以不同颜色对站点情况进行标识；通过点击站点图标，可实现测流点名称、流速、水位、经纬度、瞬间流量、累计流量及采集时间等动态实时信息的展示与调取。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577472933.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>2</b><b>、流量点管理</b></font></p><p style="text-align:left;"><font color="#000000">提供了测流点流量查询功能，管理人员通过搜索栏可直接查询各个流量点数据或者某个日期的流量信息。同时，通过平台，可对站点信息进行管理，包括站点的新增、修改、删除等。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577482947.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><font color="#000000"><b>3</b><b>、测流点历史记录</b></font></p><p style="text-align:left;"><font color="#000000">提供了测流点历史记录功能，管理人员通过搜索栏可直接查询各个流量点数据或者某个时间段内的流量信息，帮助管理人员迅速掌握河道流量变化信息，提前做好防控准备，并为后期决策提供数据支持。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577492393.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>4</b><b>、系统管理</b></font></p><p style="text-align:left;"><font color="#000000">具有权限管理、用户管理和角色管理三种功能：权限管理可针对不同用户的工作需要，进行权限设定和管理；用户管理包括用户名称、所属角色、联系电话等信息的记录，并具备用户的新增与删除功能；角色管理主要是根据用户的职务、管理范围自定义设置多级管理权限及角色，可编辑修改用户的使用状态，可以对用户权限进行编辑和删除，提高系统管理与使用的安全级别。</font></p><img src="http://files.xuruidea.com/0/20220630/image1656577500978.png" style="max-width:100%; text-align:left;" contenteditable="false"/><p style="text-align:left;"><font color="#000000"><b>5</b><b>、操作日志</b></font></p><p style="text-align:left;"><font color="#000000">对系统操作者的每一次操作进行记录、统计和查询展示，包括操作时间、操作人姓名、所属角色、操作模块名称、操作具体内容等，提高软件系统运行与操作的安全级别，实现异常操作的有据可查及追责取证。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577507340.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>6</b><b>、手机APP</b></font></p><p style="text-align:left;"><font color="#000000">自动流量站监测App，运用数字化、信息化、智能化手段提升河道流量管理效能，以流量站管理功能模板为主，支持短信预测、报警记录、数据统计分析、报警信息等功能；可根据权限定时推送当日工作情况，自动分析汇总生成工作报表；并对各类关键指标，以动态图表、文字、仪表盘的形式直观展示，方便管理人员随时查看并处理，有效提升了行政效能，使流量管理工作更简单、便捷、高效。</font></p><p style="text-align:left;"><font color="#000000"><b><br/></b></font></p><p style="text-align:left;"><font color="#000000"><b>四、案例展示</b></font></p><img src="http://files.xuruidea.com/0/20220630/image1656577514357.png" style="max-width:100%; text-align:left;" contenteditable="false"/><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;"><font color="#000000">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <font face="楷体">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 自动流量站</font></font></p>',
        proSort: 6,
        proIsShow: 1,
        createTime: "2022-05-25 09:58:08",
        languageType: 1,
      },
      {
        proId: 26,
        proType: 1,
        proName: "水利设施安防预警系统",
        proIcon:
          "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/安防报警系统3.png",
        proImg: null,
        proContent:
          '<h1 style="text-align:left;"><b style="color: rgb(0, 0, 0); font-size: 16px;"><br/></b></h1><h1 style="text-align:left;"><b style="color: rgb(0, 0, 0); font-size: 16px;">一、方案背景</b><br/></h1><p style="text-align:left;"><font color="#000000">近年来，水利设施盗窃、毁坏案件频繁发生，一些防洪、排涝、灌溉等金属铸件和泵房内动力及配套附件设备的毁坏及丢失，不仅造成严重的经济损失，也严重威胁到防汛抗旱工作的安全有序进行。据不完全统计，每年水利设施因人为破坏造成的直接经济损失在1.5亿元左右。各大江河防洪工程设施被破坏问题不断发生，每年被盗割的防汛通信线达10余万米，严重影响防汛指挥。一些提防被挖毁，防洪闸启闭机被盗窃哄抢，在洪水来临的关键时刻无法提闸，被迫炸闸泄洪。各大中型水库的设施常遭破坏，有的大坝被不法分子炸裂，严重威胁下游安全。一些水文测报站（点）的设施遭严重破坏，有的水文站被歹徒洗劫一空，人员被殴打致伤致残。农田灌排设施遭破坏的情况也十分突出，造成大片农田无法及时灌溉，影响农业生产和农业基础的稳定。</font></p><p style="text-align:left;"><font color="#000000">水利是国民经济的基础产业和基础设施，在社会主义现代化建设中起着十分重要的作用。水利设施尤其是防洪工程的安全，事关国计民生、改革开放和社会稳定的大局。为了切实保证水利设施的安全，旭瑞智能自主研发的水利设施安防报警系统，有效降低了水利设施盗窃案发率，规避了损失风险。</font></p><p style="text-align:left;"><b><font color="#000000"><br/></font></b></p><p style="text-align:left;"><b><font color="#000000">二、方案概述</font></b><br/></p><p style="text-align:left;"><font color="#000000">旭瑞智能借助多年智慧水利项目建设经验，经过技术研发与创新，不断改进和完善水利设施安防系统的功能与性能，在常规安防预警措施的基础上，增加全国首推存储设备定位追回系统，大大提高了水利设施的安全防护级别。旭瑞智能水利设施安防预警系统主要由下列五大子系统组成：&nbsp;&nbsp;</font></p><h5 style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577570631.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></h5><h5 style="text-align:left;"></h5><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font size="4" color="#000000"><br/></font></h5><h5 style="text-align:left;"><font size="4" color="#000000">三、系统功能</font></h5><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font size="2" color="#000000">1、自动语音警告系统 </font></h5><p style="text-align:left;"><font color="#000000">当现场有人非法入侵时，自动语音警告系统开启，并循环播放提前录入的语音警告，直至入侵者离开。语音警告可实现循环播放录制的语音，配置高保真音箱。可插U盘，可选择语音。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657522071194.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><font face="楷体">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1.<span style="color: rgb(0, 0, 0);">探测到有人距离设施过近&nbsp;&nbsp;&nbsp; 2.设备系统进行语音警告 &nbsp;&nbsp;&nbsp;&nbsp; </span><span style="color: rgb(0, 0, 0);">3.持续进行语音警告&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4、直至入侵者离开</span></font></p><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font color="#000000">2、远程人工喊话系统</font></h5><p style="text-align:left;"><font color="#000000">当有人距离水利设施过近，并且自动语音警告系统连续开启超过3次以上时（次数可后台设置），位于使用单位控制中心的电脑平台和手机APP上会弹出报警信息和提醒。此时，管理人员可通过调取实时监控视频来查看现场情况，决定是否进行远程人工喊话对入侵人员进行驱离。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657522437903.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><font color="#000000"><font face="楷体">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1.自动语音警告连续三次对其无效&nbsp; &nbsp; &nbsp; 2.管理工作人员查看实时监控视频&nbsp; &nbsp; &nbsp; </font></font><span style="color: rgb(0, 0, 0);"><font face="楷体">3.对入侵者开展远程人工喊话&nbsp; &nbsp; &nbsp;4.直到入侵者离开现场</font></span></p><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font color="#000000">3、门禁报警系统&nbsp;&nbsp;</font></h5><p style="text-align:left;"><font color="#000000">水利设施的电器设备远离城区，更容易被犯罪分子盯上，为了更大程度保护水利设备，我们在闸泵房的防盗门上加装了门禁报警系统。当泵房或闸室的门关闭后，门禁系统自动处于布防状态；门被打开时，门禁报警系统自动启动，同时开启声光（闪烁红色灯光并发出刺耳声音）报警，同时报警系统向平台发送报警信息。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657522759402.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <font face="楷体">&nbsp;1. 有人接近泵房&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;2.入侵者打开闸泵房防盗门&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</font></span><font face="楷体"><span style="color: rgb(0, 0, 0);">3.\n</span><span style="color: rgb(0, 0, 0);">门禁报警系统开始运行&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 4.开启声光报警(闪烁红色)</span></font></p><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font color="#000000">4、智能分析监控系统</font></h5><p style="text-align:left;"><font color="#000000">在泵房或者闸室安装具有AI智能分析功能的高清摄像机，360度无死角监控周边情况，当有人非法入侵时，可实现对入侵者的脸部进行抓拍与跟踪，能够在连续跟踪进程中保证抓拍到正面人脸，记录质量最高的面部图像并将完整的录像上传。支持镜头遮挡、视频丢失等报警功能。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657523033125.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><font color="#000000">&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<font face="楷体">&nbsp; 1.装有水利设备的泵房或者闸室&nbsp; &nbsp; &nbsp; &nbsp; 2.AI智能分析高清摄像机&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</font></font><span style="color: rgb(0, 0, 0);"><font face="楷体">3.监控入侵人员的行动轨迹&nbsp; &nbsp; &nbsp; &nbsp; 4.对人员的面部进行清晰拍照</font></span></p><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font color="#000000">5、存储设备定位追回系统</font></h5><p style="text-align:left;"><font color="#000000">对水利设施安防系统中的存储设备安装GPS定位系统，并具有双供电功能，内置高性能电池，外部供电中断时，仍可实现55天的正常工作，定位精准度高。当现场的存储设备遭到非法盗取时，可通过设备定位系统进行跟踪、定位、报警、追回。</font></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span><font color="#000000">&nbsp;&nbsp;防拆报警：可实现拆除时发送报警信息。&nbsp; &nbsp;</font></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span><font color="#000000">&nbsp;&nbsp;位移报警：可以实现设备移动时发送报警信息。&nbsp; &nbsp;</font></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span><font color="#000000">&nbsp;&nbsp;低电压报警：可实现电压低于5%时发送报警信息。&nbsp; &nbsp;</font></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span><font color="#000000">&nbsp;&nbsp;GPS+北斗定位：(定位精度：2.5m，高灵敏度：-165dBm)，4G/5G通讯。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657523381465.png" style="font-size: 14px; max-width: 100%;" contenteditable="false"/></p><p style="text-align:left;"><font color="#000000">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<font face="楷体">&nbsp;1.安装有设备的泵房&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;2.泵房内的储存设备&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</font></font><span style="color: rgb(0, 0, 0);"><font face="楷体">3.丢失存储设备的精准定位&nbsp; &nbsp; &nbsp; &nbsp; 4.详细记录丢失设备被运输的路径</font></span></p>',
        proSort: 7,
        proIsShow: 1,
        createTime: "2022-05-25 09:58:08",
        languageType: 1,
      },
      {
        proId: 27,
        proType: 1,
        proName: "智慧水利-后台管理子系统",
        proIcon:
          "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/智慧水利-后台管理子系统-02.png",
        proImg: null,
        proContent:
          '<h1 style="text-align:left;"><b style="font-size: 16px;"><br/></b></h1><h1 style="text-align:left;"><b style="font-size: 16px;">一、</b><b style="font-size: 16px;">系统概述</b><br/></h1><p style="text-align:left;">后台管理系统是对系统使用者的各类基础信息进行维护和管理，主要功能包含用户管理、角色管理、权限管理及操作日志等，能够更好的管理各个业务流程步骤中每一位用户的权限，防止用户操作混乱，使流程更清晰、任务更明确。</p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577863764.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><b><br/></b></p><p style="text-align:left;"><b>二、系统功能</b></p><p style="text-align:left;"><b>1</b><b>、用户管理模块</b></p><p style="text-align:left;">可对用户信息、组织机构信息等进行管理，包括对组织机构及用户信息的新增、编辑、修改、删除和账户禁用等功能；同时系统具备组织架构职责权限设置的功能。</p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577872161.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><b>2</b><b>、角色管理模块</b></p><p style="text-align:left;">角色管理主要是根据用户的职务、管理范围自定义设置多级管理权限及角色，可编辑修改用户的使用状态，可以对用户权限进行编辑和删除，提高系统管理与使用的安全级别。</p><p style="text-align:left;">采用最安全且强大的shiro安全框架进行系统开发,按照安全规则或者安全策略使用户可以访问且只能访问自己被授权的资源，实现对用户访问权限的控制。</p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577879848.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><b>3</b><b>、操作日志模块</b></p><p style="text-align:left;">对系统操作者的每一次操作进行记录、统计和查询展示，包括操作时间、操作人姓名、所属部门、岗位、操作模块名称、操作具体内容等，提高软件系统运行与操作的安全级别，实现异常操作的有据可查及追责取证。</p><p style="text-align:left;">通过使用Log4j开发技术，可将日志信息输送的目的地设定为控制台、文件、GUI组件、甚至是套接口服务器、NT的事件记录器、UNIX Syslog守护进程等。</p><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577887802.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p>',
        proSort: 8,
        proIsShow: 1,
        createTime: "2022-05-25 09:58:08",
        languageType: 1,
      },
      {
        proId: 28,
        proType: 1,
        proName: "智慧水利-手机APP",
        proIcon:
          "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/智慧水利手机APP-02.png",
        proImg: null,
        proContent:
          '<h4></h4><h4 style="text-align:left;"><br/></h4><h4 style="text-align:left;"><!--[if-->一、<!--[endif]-->系统概述</h4><p style="text-align:left;">智慧水利手机APP是一款基于智慧水利综合管理平台，专为水利设施设备运维及管理人员打造的一款移动软件，支持实时数据查询、设备报警、远程控制、实时监控、工单处理等功能，为水利相关管理部门的日常工作提供更便捷、更高效的管理模式。</p><p style="text-align:left;">智慧水利手机APP界面设计简约，操作简单，使用不受时间、空间限制，只需一部可以上网的安卓系统手机即可，随时随地智能管控，方便快捷。</p><p><img src="http://files.xuruidea.com/0/20220711/微信截图_202207111830531657535469829.png" style="max-width:100%;" width="670.5" height="412.26" contenteditable="false"/></p><p><b>二、系统功能</b><br/></p><p style="text-align:left;">1&nbsp;、智慧水利APP，运用数字化、信息化、智能化手段提升水利管理效能，以闸泵远程控制、测流点监测、雨情、水位站、积水点、安防预警等功能模板为主，支持短信预警、报警记录、数据统计分析等功能；</p><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;">2、可根据权限定时推送当日工作情况，自动分析汇总生成工作报表；并对各类关键指标，以动态图表、文字、仪表盘的形式直观展示，方便水利管理人员随时查看并处理，有效提升了行政效能，使水利管理工作更简单、便捷、高效。</p>',
        proSort: 9,
        proIsShow: 1,
        createTime: "2022-05-25 09:58:08",
        languageType: 1,
      },
    ];
    this.Rid = this.$store.state.num;
    console.log(this.$route.query.id, "跳转ID");
    this.queryId = this.$route.query.id;

    // 头部导航跳转
    if (this.queryId == 0) {
      this.caseClick(0);
    }
    if (
      this.queryId == 1 ||
      this.$route.query.Tid == 21 ||
      this.$route.query.Tid == 22 ||
      this.$route.query.Tid == 23 ||
      this.$route.query.Tid == 24 ||
      this.$route.query.Tid == 25
    ) {
      this.caseClick(1);
    }
    if (
      this.queryId == 2 ||
      this.$route.query.Tid == 31 ||
      this.$route.query.Tid == 32 ||
      this.$route.query.Tid == 33 ||
      this.$route.query.Tid == 34 ||
      this.$route.query.Tid == 35
    ) {
      this.caseClick(2);
    }

    
  },
  mounted() {
    console.log(this.Rid);

    window.addEventListener("scroll", this.handleScrollx, true);

    if (this.$route.query.Tid == 11) {
      document.querySelector("#construction1").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 12) {
      document.querySelector("#architecture1").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 13) {
      document.querySelector("#undertaking1").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 14) {
      document.querySelector("#functional_module1").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 15) {
      document.querySelector("#Related_Products1").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 21) {
      document.querySelector("#construction2").scrollIntoView(true);
    }

    if (this.$route.query.Tid == 22) {
      document.querySelector("#functional_module2").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 23) {
      document.querySelector("#undertaking2").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 24) {
      document.querySelector("#Enterprise_Architecture2").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 25) {
      document.querySelector("#Related_Products2").scrollIntoView(true);
    }
    if (this.queryId == 2) {
      // document.querySelector("#undertaking1").style.height = "0";
    }
    if (this.$route.query.Tid == 31) {
      document.querySelector("#construction3").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 32) {
      document.querySelector("#Solution_Architecture3").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 33) {
      document.querySelector("#architecture3").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 34) {
      document.querySelector("#Solution_Architecture4").scrollIntoView(true);
    }
    if (this.$route.query.Tid == 35) {
      document.querySelector("#architecture4").scrollIntoView(true);
    }
  },

  methods: {
    gotoback() {
     
      this.$router.push({
        query: {
          name: "#content",
        },
      });
      
    },
    ...mapMutations(["setNum"]),
    handleScrollx() {
      if (this.$refs.header.getBoundingClientRect().top < 210) {
        this.show = false;
        this.show1 = true;
      }
      if (this.$refs.header.getBoundingClientRect().top > 210) {
        this.show = true;
        this.show1 = false;
      }
    },
    // 软件水利详情跳转
    gotoSoftWareShuiDetail(item) {
      // console.log(item);
      let id = item.proId;
      let type = 1;
      this.$router.push({ path: `/softwareDetail/${id}/${type}` });
    },
    // 软件城管详情跳转
    gotoSoftWareChengDetail(item) {
      // console.log(item);
      let id = item.proId;
      let type = 2;
      this.$router.push({ path: `/softwareDetail/${id}/${type}` });
    },
    // 软件农业详情跳转
    gotoSoftWareNongDetail(item) {
      // console.log(item);
      let id = item.proId;
      let type = 3;
      this.$router.push({ path: `/softwareDetail/${id}/${type}` });
    },
    // 硬件产品ALL
    getHardware() {
      let data = {};
      this.$API.getHardware(data).then((res) => {
        console.log("res :硬件产品列表>> ", res);
        this.HardwareList = res.data;
      });
    },
    caseClick(index) {
      this.Cindex = index;
      // console.log(this.Rid, "路由id");
      console.log(index, "点击选择的id");

      this.queryId = index;
      // this.autocades(this.Cindex);
      this.autocades(index * 1 + 1);
      // this.setNum(index);
      // if(!this.$route.query.id){
      //     this.$router.push({
      //     query: {
      //       name: "#content",
      //     },
      //   });
      // }
      //  this.$router.go(0)
      if (
        this.$route.query.Tid == 11 ||
        this.$route.query.Tid == 12 ||
        this.$route.query.Tid == 13 ||
        this.$route.query.Tid == 14 ||
        this.$route.query.Tid == 15
        // ||
        // this.$route.query.Tid == 21
        // this.$route.query.Tid == 22 ||
        // this.$route.query.Tid == 23 ||
        // this.$route.query.Tid == 24 ||
        // this.$route.query.Tid == 25 ||
        // this.$route.query.Tid == 31 ||
        // this.$route.query.Tid == 32 |
        // this.$route.query.Tid == 33 ||
        // this.$route.query.Tid == 34 ||
        // this.$route.query.Tid == 35
      ) {
        this.$router.push({
          query: {
            name: "#content",
          },
        });
      }
      if (this.$route.query.Tid == 21) {
        document.querySelector("#content").scrollIntoView(true);
      }
      if (this.$route.query.Tid == 22) {
        document.querySelector("#content").scrollIntoView(true);
      }
      if (this.$route.query.Tid == 23) {
        document.querySelector("#content").scrollIntoView(true);
      }
      if (
        this.$route.query.Tid == 24 ||
        this.$route.query.Tid == 31 ||
        this.$route.query.Tid == 32 ||
        this.$route.query.Tid == 33 ||
        this.$route.query.Tid == 34 ||
        this.$route.query.Tid == 35
      ) {
        document.querySelector("#content").scrollIntoView(true);
      }
      // if()
    },
    autocades(index) {
      let data = {
        proType: index,
        // proType:3
        // proTyPe:index+1
      };
      // console.log(Cindex);
      this.$API.getSoftware(data).then((res) => {
        console.log("软件产品", res);
        this.Software = res.data;
        console.log(this.Software);
      });
    },
    prev() {
      if (this.pageNum <= "1") {
        this.pageNum = 2;
      }
      let data = {
        pageNum: --this.pageNum,
        pageSize: 4,
      };
      this.$API.getFenYeHardware(data).then((res) => {
        console.log("res :硬件>> ", res);
        this.hardware = res.data.list;
      });
    },
    next() {
      if (this.pageNum <= this.page) {
        this.pageNum = this.page;
      }

      let data = {
        pageNum: ++this.pageNum,
        pageSize: 4,
      };
      this.$API.getFenYeHardware(data).then((res) => {
        this.hardware = res.data.list;
      });
    },

    detail(id) {
      this.$router.push({ path: "/ProgrammeDetails", query: { id } });
    },
    // 顶部轮播
    rotation() {
      let data = {
        itiItId: 4,
      };
      this.$API.getBanner(data).then((res) => {
        console.log("轮播图", res);
        this.bannerList = res.data;
        res.data.forEach((v) => {
          // this.background.push(v.itiImgUrl);
        });
      });
    },
    // 软件产品
    // autocades(Cindex) {
    //   let data = {
    //     proType: Cindex + 1,
    //     // proType:3
    //   };
    //   // console.log(Cindex);
    //   this.$API.getSoftware(data).then((res) => {
    //     console.log("软件产品", res);
    //     this.Software = res.data;
    //     console.log(this.Software);
    //   });
    // },
    // 硬件产品
    hardwares() {
      let data = {
        pageNum: 1,
        pageSize: 4,
      };
      this.$API.getFenYeHardware(data).then((res) => {
        console.log("res :硬件>> ", res);
        this.hardware = res.data.list;
      });
    },
    // 硬件详情
    gotoDetail(val) {
      console.log(val);
      let id = val.devId;
      this.$router.push({ path: `/HardwareDetail/${id}` });
    },
    // 轮播跳转
    gotoCase(val) {
      let id = val.itiSort;
      console.log(id);
      this.$router.push({
        path: "/case",
        query: { id: id },
      });
    },
  },
   watch: {
   
    $route(to,form){
     if(to.name == form.name){
       this.$router.go(0)
     }
    }
  },
};
</script>
<style lang="less" scoped>
h2 {
  font-size: 40px;
  margin-top: -9px;
}
.header1 {
  height: 70px;
  width: 1px;
}
.demo-tabs > .el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}
.page {
  width: 100%;
  .banner_box {
    width: 100%;
    /deep/.el-carousel__container {
      width: 100%;
      height: 700px;
    }
    img {
      width: 100%;
    }
  }
  .list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .item {
      width: 23%;
      margin: 2% 1%;
      height: 400px;
      background-color: #004aa1;
      border-radius: 10px;
      box-shadow: 0 0 10px 5px #dcdcdc;
      .devImg {
        width: 100%;
        height: 300px;
        // border-radius: 8
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        background-color: #fff;

        img {
          width: 100%;
          height: 100%;
          border-radius: 8px;
          text-align: center;
        }
      }

      .text {
        width: 100%;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        color: #fff;
        p {
          font-size: 18px;
          font-weight: 600;
        }
        button {
          cursor: pointer;
          display: block;
          padding: 5px 40px;
          border: 1px solid #fff;
          border-radius: 20px;
          color: white;
          background-color: #004aa1;
        }
        button:hover {
          color: black;
          background-color: #fff;
        }
        span:hover {
          background-color: #fff;
          color: #004aa1;
        }
      }
    }
  }
  .content {
    width: 60%;
    margin: 50px auto;
    position: relative;
    .header {
      display: flex;
      justify-content: center;
      margin-bottom: 100px;
      .case_item {
        cursor: pointer;
        width: 33%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(226, 225, 225, 0.5);
        overflow: hidden;
        img {
          width: 40px;
          height: 30px;
          margin-right: 10px;
        }
        span {
          font-size: 26px;
          color: #004aa1;
        }
      }
      .bg,
      .active_bg {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .active_bg {
        background-color: rgba(0, 0, 0, 0.5);
      }
      .case_item:nth-child(1) {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        border-right: 1px solid #fff;
      }

      .case_item:nth-last-child(1) {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        border-left: 1px solid #fff;
      }
      .active {
        background-repeat: no-repeat;
        background-size: 100% 100%;
        span {
          color: #fff;
        }
      }
    }
    .issFixed {
      position: fixed;
      top: 82px;
      left: 0px;
      right: 0;
      width: 30%;
      margin: auto;
      z-index: 999;
      .case_item {
        margin-right: 30px;
        height: 20px;
        padding: 20px;
        z-index: 99999999;
        background-color: rgba(235, 235, 235, 0.9);
        img {
          width: 20px;
          height: 20px;
        }
        span {
          font-size: 16px;
          // font-weight: 700;
        }
      }
      .bg,
      .active_bg {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        // font-weight: 700;
      }
      .case_item:nth-child(1) {
        border-radius: 50px;
        border-right: 1px solid #fff;
      }
      .case_item:nth-child(2) {
        border-radius: 50px;
        border-right: 1px solid #fff;
      }

      .case_item:nth-last-child(1) {
        border-radius: 50px;
        border-left: 1px solid #fff;
      }
      .active_bg {
        background-color: rgba(0, 0, 0, 0);
        // font-weight: 700;
      }
      // .case_item:hover {
      //   background-color: rgb(245, 245, 245);
      //   // font-weight: 700;
      // }
      .active {
        background-size: 10000% 10000%;
        background-color: rgba(235, 235, 235, 1);
        span {
          color: #004aa1;
        }
        img {
          color: #004aa1;
        }
      }
    }
    .Scheme_overview {
      .title {
        display: flex;
        margin-top: 119px;
        span:nth-child(1) {
          display: block;
          width: 8px;
          height: 38px;
          background-color: #024b9a;
          margin-right: 10px;
        }
        span:nth-child(2) {
          margin-top: -8px;
          font-size: 40px;
          width: 161px;
          height: 40px;
          font-size: 40px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
        }
      }
      .overview {
        p {
          line-height: 30px !important;
        }
        p:nth-child(1) {
          margin-top: 57px;
          margin-bottom: 57px;
          line-height: 25px;
        }
        p:nth-child(2) {
          line-height: 25px;
        }
      }
      .overview3 {
        margin-bottom: -60px;
        p {
          line-height: 30px !important;
        }
        p:nth-child(1) {
          margin-top: 57px;
          margin-bottom: 57px;
          line-height: 25px;
        }
        p:nth-child(2) {
          line-height: 25px;
        }
      }
      .features {
        margin-top: 99px;
        margin-left: 20px;
        display: flex;
        .analysis {
          div {
            margin-top: 23px;
            margin-left: 25px;
            font-weight: 700;
          }
        }
        img {
          width: 120px;
          height: 120px;
          margin-top: -39px;
        }
        p:nth-child(1) {
          width: 200px;
          height: 50px;
          background: #ffffff;
          border: 1px dashed #3669ab;
          border-radius: 25px;
          text-align: center;
          line-height: 50px;
          color: #004aa1;
        }
        p:nth-child(2) {
          width: 80px;
          height: 1px;
          background-color: #024b9a;
          margin-top: 19px;
        }
        .features_p3 {
          width: 80px !important;
          height: 1px;
          background-color: #024b9a;
          margin-top: 19px;
        }
        .features_p4 {
          width: 80px !important;
          height: 1px;
          background-color: #024b9a;
          margin-top: 19px;
        }
        .features_p5 {
          width: 80px !important;
          height: 1px;
          background-color: #024b9a;
          margin-top: 19px;
        }
      }
      .construction {
        // p {
        //   line-height: 30px !important;
        position: relative;
        // }
        .construction11 {
          position: absolute;
          top: -200px;
        }
        .construction22 {
          position: absolute;
          top: -200px;
        }

        .overview3 {
          margin-top: 68px;
          width: 1190px;
          height: 50px;
          // font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
        }
        img {
          margin: 0px auto;
        }
        .mentality {
          ul {
            display: flex;
            justify-content: space-around;
            margin-top: 100px;
          }
          li {
            width: 30%;
            text-align: center;

            img {
              margin-top: 82px;
            }
            p {
              margin-top: 33px;
            }
          }
        }
        .mentality1 {
          .left_box {
            margin-top: 100px;
            img {
              // border-bottom: 1px dashed #333;
              // border-left: 1px dashed #333;
              // border-right: 1px dashed #333;
              // padding-top: 20px;
              // border-top: 1px dashed #333;
            }
          }
          .right_box {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            margin-top: 100px;
            margin-left: 100px;
            .right_box_left {
              display: flex;
              padding-bottom: 10px;
              border-bottom: 1px dashed;
              .right_box_box {
                width: 140px;
                text-align: center;
                margin-top: 4px;
                p {
                  width: 65px;
                  height: 16px;
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: bold;
                  color: #004aa1;
                  margin: auto;
                }
              }
              .right_box_size {
                margin-left: 10px;
                width: 424px;
                height: 72px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                .p1 {
                  margin-top: 23px;
                }
              }
            }
          }
          .top_box {
            display: flex;
            position: relative;
            margin-top: 30px;
            .bottom_box {
              position: absolute;
              top: 422px;
              left: 319px;
              .top {
                .top_top {
                  display: flex;
                  justify-content: space-around;
                  p {
                    // background-color: red;
                    line-height: 50px;
                    color: #004aa1;
                    border: 1px dashed #004aa1;
                    border-radius: 25px;
                    width: 150px;
                    text-align: center;
                    margin-right: 32px;
                    font-weight: 700;
                  }
                }
                .top_bottom {
                  display: flex;
                  .list1 {
                    width: 104px !important;
                    height: 137px;
                    background-color: #004aa1;
                    margin-left: 25px;
                    margin-top: 20px;
                    position: relative;
                    p {
                      color: #fff;
                      text-align: center;
                      line-height: 25px;
                      font-weight: 300;
                    }
                    span {
                      display: block;
                      width: 0;
                      height: 0;
                      border: 9px solid transparent;
                      border-bottom-color: #004aa1;
                      // border-bottom-color: #fff;
                      position: absolute;
                      top: -18px;
                      left: 50%;
                      transform: translate(-50%);
                    }
                    p:nth-child(1) {
                      padding-top: 15px;
                    }
                  }
                  .list2 {
                    margin-left: 80px;
                  }
                  .list3 {
                    margin-left: 80px;
                  }
                }
              }
            }
            .list {
              // width: 550px;
              width: 44%;
              height: 13%;
              border-radius: 30px;
              background: #004aa1;
              position: absolute;
              top: 10px;
              left: 285px;
              display: flex;
              justify-content: space-around;
              padding: 0 30px;
              p {
                color: #fff;
                font-weight: 500;
                line-height: 50px;
                border-left: 50px;
                padding-right: 5px;
                font-size: 15px;
                padding: 0 7px;
              }
              span {
                display: block;
                width: 1px;
                height: 36px;
                border-left: 1px dashed #999;
                margin-top: 6px;
                // background-color: red;
                // margin: 0 0px
              }
            }
            .top_box {
              display: flex;
              width: 500px;
              height: 300px;
              margin: auto;
              margin-top: 8%;
              border: 1px dashed #024b9a;
              border-radius: 5%;
              position: relative;
              .prev,
              .next {
                position: absolute;
                top: 34%;
                transform: translate(0%, -50%);
              }
              .prev {
                left: 0;
              }
              .next {
                right: 0;
              }
              .box_ball {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #024b9a;
                position: absolute;
                top: 50%;
                transform: translate(50%, -50%);
                margin-left: -10px !important;
              }
              .box_ball:nth-child(1) {
                left: 0;
              }
              .box_ball:nth-child(2) {
                right: 0;
              }
              .center_box {
                margin: auto;
                // border-bottom: 1px dashed #333;
                //  border-right: 1px dashed #333;
                //   border-left: 1px dashed #333;
                //    border-top: 1px dashed #333;
                // border: 1px dashed #333;
                padding-top: 10px;
                margin-top: 5.5%;
              }
            }
            .left_box {
              width: 60px;
              height: 409px;
              // background-color: red;
              border-bottom: 1px dashed #024b9a;
              border-top: 1px dashed #024b9a;
              border-right: 1px dashed #024b9a;
              border-top-right-radius: 5px;
              border-bottom-right-radius: 5px;
              position: absolute;
              left: 204px;
              top: -51px;
              .left_box_ball {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #024b9a;
                position: absolute;
                top: 50%;
                left: 92%;
              }
              .left_box_line {
                width: 56px;
                height: 1px;
                border-bottom: 2px dashed #024b9a;
                margin-top: 200px;
                margin-left: 62px;
                transform: rotate(164deg);
              }
            }
            .right_box {
              width: 60px;
              height: 409px;
              // background-color: red;
              border-bottom: 1px dashed #024b9a;
              border-top: 1px dashed #024b9a;
              border-left: 1px dashed #024b9a;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
              position: absolute;
              left: 790px;
              top: -51px;
              .right_box_ball {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #024b9a;
                position: absolute;
                top: 50%;
                left: -5px;
              }
              .right_box_line {
                width: 56px;
                height: 1px;
                border-bottom: 2px dashed #024b9a;
                margin-top: -8px;
                margin-left: -60px;
                transform: rotate(376deg);
              }
            }
            .left_box_content {
              position: absolute;
              top: 100px;
              left: 100px;
              p {
                text-align: right;
                line-height: 45px;
                span {
                  font-weight: 700;
                  color: #024b9a;
                }
              }
              p:nth-child(1) {
                font-weight: 700;
                color: #024b9a;
              }
            }
            .right_box_content {
              position: absolute;
              top: 100px;
              left: 918px;
              p {
                text-align: left;
                line-height: 45px;
                span {
                  font-weight: 700;
                  color: #024b9a;
                }
              }
              p:nth-child(1) {
                font-weight: 700;
                color: #024b9a;
              }
            }
          }
        }
      }
      .construction3 {
        position: relative;
        .construction33 {
          position: absolute;
          top: -200px;
        }
        margin-top: 160px;
        .overview3 {
          margin-top: 48px;
          width: 1190px;
          height: 50px;
          // font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
        }
        img {
          margin: 0px auto;
        }
        .mentality {
          ul {
            display: flex;
            justify-content: space-around;
          }
          li {
            width: 30%;
            text-align: center;

            img {
              margin-top: 82px;
            }
            p {
              margin-top: 33px;
            }
          }
        }
        .mentality1 {
          .left_box {
            margin-top: 100px;
            img {
              // border-bottom: 1px dashed #333;
              // border-left: 1px dashed #333;
              // border-right: 1px dashed #333;
              // padding-top: 20px;
              // border-top: 1px dashed #333;
            }
          }
          .right_box {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            margin-top: 100px;
            margin-left: 100px;
            .right_box_left {
              display: flex;
              padding-bottom: 10px;
              border-bottom: 1px dashed;
              .right_box_box {
                width: 140px;
                text-align: center;
                margin-top: 4px;
                p {
                  width: 65px;
                  height: 16px;
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: bold;
                  color: #004aa1;
                  margin: auto;
                }
              }
              .right_box_size {
                margin-left: 10px;
                width: 424px;
                height: 72px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                .p1 {
                  margin-top: 23px;
                }
              }
            }
          }
          .top_box {
            display: flex;
            position: relative;
            margin-top: 30px;
            .bottom_box {
              position: absolute;
              top: 422px;
              left: 319px;
              .top {
                .top_top {
                  display: flex;
                  justify-content: space-around;
                  p {
                    // background-color: red;
                    line-height: 50px;
                    color: #004aa1;
                    border: 1px dashed #004aa1;
                    border-radius: 25px;
                    width: 150px;
                    text-align: center;
                    margin-right: 32px;
                    font-weight: 700;
                  }
                }
                .top_bottom {
                  display: flex;
                  .list1 {
                    width: 104px !important;
                    height: 137px;
                    background-color: #004aa1;
                    margin-left: 25px;
                    margin-top: 20px;
                    position: relative;
                    p {
                      color: #fff;
                      text-align: center;
                      line-height: 25px;
                      font-weight: 300;
                    }
                    span {
                      display: block;
                      width: 0;
                      height: 0;
                      border: 9px solid transparent;
                      border-bottom-color: #004aa1;
                      // border-bottom-color: #fff;
                      position: absolute;
                      top: -18px;
                      left: 50%;
                      transform: translate(-50%);
                    }
                    p:nth-child(1) {
                      padding-top: 15px;
                    }
                  }
                  .list2 {
                    margin-left: 80px;
                  }
                  .list3 {
                    margin-left: 80px;
                  }
                }
              }
            }
            .list {
              // width: 550px;
              width: 44%;
              height: 13%;
              border-radius: 30px;
              background: #004aa1;
              position: absolute;
              top: 10px;
              left: 285px;
              display: flex;
              justify-content: space-around;
              padding: 0 30px;
              p {
                color: #fff;
                font-weight: 500;
                line-height: 50px;
                border-left: 50px;
                padding-right: 5px;
                font-size: 15px;
                padding: 0 7px;
              }
              span {
                display: block;
                width: 1px;
                height: 36px;
                border-left: 1px dashed #999;
                margin-top: 6px;
                // background-color: red;
                // margin: 0 0px
              }
            }
            .top_box {
              display: flex;
              width: 500px;
              height: 300px;
              margin: auto;
              margin-top: 8%;
              border: 1px dashed #024b9a;
              border-radius: 5%;
              position: relative;
              .prev,
              .next {
                position: absolute;
                top: 34%;
                transform: translate(0%, -50%);
              }
              .prev {
                left: 0;
              }
              .next {
                right: 0;
              }
              .box_ball {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #024b9a;
                position: absolute;
                top: 50%;
                transform: translate(50%, -50%);
                margin-left: -10px !important;
              }
              .box_ball:nth-child(1) {
                left: 0;
              }
              .box_ball:nth-child(2) {
                right: 0;
              }
              .center_box {
                margin: auto;
                // border-bottom: 1px dashed #333;
                //  border-right: 1px dashed #333;
                //   border-left: 1px dashed #333;
                //    border-top: 1px dashed #333;
                // border: 1px dashed #333;
                padding-top: 10px;
                margin-top: 5.5%;
              }
            }
            .left_box {
              width: 60px;
              height: 409px;
              // background-color: red;
              border-bottom: 1px dashed #024b9a;
              border-top: 1px dashed #024b9a;
              border-right: 1px dashed #024b9a;
              border-top-right-radius: 5px;
              border-bottom-right-radius: 5px;
              position: absolute;
              left: 204px;
              top: -51px;
              .left_box_ball {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #024b9a;
                position: absolute;
                top: 50%;
                left: 92%;
              }
              .left_box_line {
                width: 56px;
                height: 1px;
                border-bottom: 2px dashed #024b9a;
                margin-top: 200px;
                margin-left: 62px;
                transform: rotate(164deg);
              }
            }
            .right_box {
              width: 60px;
              height: 409px;
              // background-color: red;
              border-bottom: 1px dashed #024b9a;
              border-top: 1px dashed #024b9a;
              border-left: 1px dashed #024b9a;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
              position: absolute;
              left: 790px;
              top: -51px;
              .right_box_ball {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #024b9a;
                position: absolute;
                top: 50%;
                left: -5px;
              }
              .right_box_line {
                width: 56px;
                height: 1px;
                border-bottom: 2px dashed #024b9a;
                margin-top: -8px;
                margin-left: -60px;
                transform: rotate(376deg);
              }
            }
            .left_box_content {
              position: absolute;
              top: 100px;
              left: 100px;
              p {
                text-align: right;
                line-height: 45px;
                span {
                  font-weight: 700;
                  color: #024b9a;
                }
              }
              p:nth-child(1) {
                font-weight: 700;
                color: #024b9a;
              }
            }
            .right_box_content {
              position: absolute;
              top: 100px;
              left: 918px;
              p {
                text-align: left;
                line-height: 45px;
                span {
                  font-weight: 700;
                  color: #024b9a;
                }
              }
              p:nth-child(1) {
                font-weight: 700;
                color: #024b9a;
              }
            }
          }
        }
      }
      .Construction_goal {
        position: relative;
     .Construction_goal22 {
       position: absolute;
       top: -200px;
     }
        p {
          line-height: 30px !important ;
        }
        .bottom_box {
          display: flex;
          justify-content: space-around;
          .bottom_box_list {
            border: 1px solid #024b9a;
            margin-top: 40px;
            padding: 30px;
            position: relative;
            width: 15%;
            border-radius: 5px;
            text-align: center;
            img {
              position: absolute;
              top: -35px;
              left: 73px;
            }
            .list_p {
              margin: 30px 0 20px;
              color: #023b9a;
            }
          }
        }
      }
      .Solution_Architecture3 {
        // margin-top: 200px;
        position: relative;
        .Solution_Architecture33 {
          position: absolute;
          top: -200px;
        }
        p {
          line-height: 30px !important ;
        }
        .bottom_box {
          margin-top: 60px;
          display: flex;
          justify-content: space-around;
          .bottom_box_list {
            border: 1px solid #024b9a;
            margin-top: 40px;
            padding: 30px;
            position: relative;
            width: 15%;
            border-radius: 5px;
            text-align: center;
            img {
              position: absolute;
              top: -35px;
              left: 73px;
            }
            .list_p {
              margin: 30px 0 20px;
              color: #023b9a;
            }
          }
        }
      }
      .architecture {
        position: relative;
        .architecture11 {
          position: absolute;
          top: -200px;
        }
        p {
          line-height: 30px !important;
        }
        // margin-top: -190px;
        .overview4 {
          margin-top: 71px;
          width: 1188px;
          height: 81px;
          // font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
        }
      }
      .architecture3 {
        margin-bottom: -100px;
        position: relative;
        .architecture33 {
          position: absolute;
          top: -200px;
        }
        p {
          line-height: 30px !important;
        }
        margin-top: 90px;
        .overview4 {
          margin-top: 71px;
          width: 1188px;
          height: 81px;
          // font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
        }
      }
      .undertaking {
        position: relative;
        .undertaking11 {
          position: absolute;
          top: -200px;
        }
        // p {
        //   line-height: 30px !important;
        // }
        margin-top: 104px;
        p {
          margin-top: 70px;
          margin-bottom: 84px;
        }
        .title_content {
          display: flex;
          justify-content: space-around;
          .listt {
            text-align: center;
            img {
              width: 24px;
              height: 24px;
            }
            span {
              display: block;
              width: 2px;
              height: 30px;
              border-left: 1px solid #004aa1;
              margin: auto;
            }
            p {
              margin-top: 8px;
              margin-bottom: 5px;
            }
            .top_box {
              width: 150px;
              height: 40px;
              // background-color: red;
              border-top: 1px dashed #004aa1;
              border-left: 1px dashed #004aa1;
              border-right: 1px dashed #004aa1;
              border-top-left-radius: 8px;
              border-top-right-radius: 8px;
            }

            .bottom_box {
              width: 150px;
              height: 40px;
              // background-color: red;
              border-bottom: 1px dashed #004aa1;
              border-left: 1px dashed #004aa1;
              border-right: 1px dashed #004aa1;
              border-bottom-right-radius: 8px;
              border-bottom-left-radius: 8px;
            }
            .bottom_div {
              width: 130px;
              line-height: 40px;
              background-color: #004aa1;
              text-align: center;
              color: #fff;
              border-radius: 50px;
              margin: auto;
            }
          }
        }
      }
      .undertaking2 {
        position: relative;
        .undertaking22 {
          position: absolute;
          top: -180px;
        }
        // p {
        //   line-height: 30px !important;
        // }
        // margin-top: -244px;
        p {
          margin-top: 70px;
          margin-bottom: 84px;
        }
        .title_content {
          display: flex;
          justify-content: space-around;
          .listt {
            text-align: center;
            img {
              width: 24px;
              height: 24px;
            }
            span {
              display: block;
              width: 2px;
              height: 30px;
              border-left: 1px solid #004aa1;
              margin: auto;
            }
            p {
              margin-top: 8px;
              margin-bottom: 5px;
            }
            .top_box {
              width: 150px;
              height: 40px;
              // background-color: red;
              border-top: 1px dashed #004aa1;
              border-left: 1px dashed #004aa1;
              border-right: 1px dashed #004aa1;
              border-top-left-radius: 8px;
              border-top-right-radius: 8px;
            }

            .bottom_box {
              width: 150px;
              height: 40px;
              // background-color: red;
              border-bottom: 1px dashed #004aa1;
              border-left: 1px dashed #004aa1;
              border-right: 1px dashed #004aa1;
              border-bottom-right-radius: 8px;
              border-bottom-left-radius: 8px;
            }
            .bottom_div {
              width: 130px;
              line-height: 40px;
              background-color: #004aa1;
              text-align: center;
              color: #fff;
              border-radius: 50px;
              margin: auto;
            }
          }
        }
      }
      .functional_module {
        margin-top: 100px;
        position: relative;
        .functional_module11 {
          position: absolute;
          top: -180px;
        }
        p {
          line-height: 30px !important;
        }
        .title {
          margin-top: 40px;
          margin-bottom: 70px;
        }
        .overview5 {
          width: 1193px;
          height: 81px;
          // font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
        }

        .module_div {
          display: flex;
          margin-top: 51px;
          img {
            margin: auto;
          }
        }
      }
      .functional_module2 {
        // margin-top: -140px;
        position: relative;
        .functional_module22 {
          position: absolute;
          top: -200px;
        }
        p {
          line-height: 30px !important;
        }
        .title {
          margin-top: 40px;
          margin-bottom: 70px;
        }
        .overview5 {
          width: 1193px;
          height: 81px;
          // font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
        }

        .module_div {
          display: flex;
          margin-top: 51px;
          img {
            margin: auto;
          }
        }
      }
      .Enterprise_Architecture {
        position: relative;
        .Enterprise_Architecture22 {
          position: absolute;
          top: -80px;
        }
        p {
          line-height: 30px !important;
        }
        display: flex;
        flex-direction: column;
        img {
          width: 1153px;
          margin: auto;
        }
      }
      .Related_Products {
        z-index: 1;
        position: relative;
        .Related_Products11 {
          position: absolute;
          top: -190px;
        }
        .Related_Products22 {
          position: absolute;
          top: -190px;
        }
        p {
          line-height: 30px !important;
        }
        #Hardware {
          position: absolute;
          top: 1100px;
          left: 0;
        }
        /deep/ .el-tabs__nav {
          transform: translateX(511px) !important;
        }
        // /deep/ .el-tabs__item {
        //   margin-left: 34px;
        // }
        // /deep/ .el-tabs__active-bar {
        //   transform: translateX(20px)
        //   !important;
        // }
        .tabs {
          margin-top: 30px;
          ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            li {
              width: 15%;
              text-align: center;
              margin-bottom: 20px;
              img {
                margin-top: 46px;
              }
              p {
                margin-top: 20px;
              }
            }
          }
        }
        .list {
          margin-top: 80px;
          position: relative;
          .img1,
          .img2 {
            width: 40px;
            height: 40px;
            position: absolute;
            top: 150px;
          }
          .img1 {
            left: -80px;
            // top: 150px;
          }
          .img2 {
            left: 1180px;
            // top: 150px;
          }
        }
      }
      .Related_Products1 {
        z-index: 1;
        position: relative;
        margin-top: 200px;
        .architecture44 {
          position: absolute;
          top: -170px;
        }
        p {
          line-height: 30px !important;
        }
        #Hardware {
          position: absolute;
          top: 1100px;
          left: 0;
        }
        /deep/ .el-tabs__nav {
          transform: translateX(511px) !important;
        }
        // /deep/ .el-tabs__item {
        //   margin-left: 34px;
        // }
        // /deep/ .el-tabs__active-bar {
        //   transform: translateX(20px)
        //   !important;
        // }
        .tabs {
          margin-top: 30px;
          ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            li {
              width: 15%;
              text-align: center;
              margin-bottom: 20px;
              img {
                margin-top: 46px;
              }
              p {
                margin-top: 20px;
              }
            }
          }
        }
        .list {
          margin-top: 80px;
          position: relative;
          .img1,
          .img2 {
            width: 40px;
            height: 40px;
            position: absolute;
            top: 150px;
          }
          .img1 {
            left: -80px;
            // top: 150px;
          }
          .img2 {
            left: 1180px;
            // top: 150px;
          }
        }
      }
    }
  }
}
</style>